import { log, callAdminAjax, updateLoadingSpinner, getTemplate, nextFrame, delay, splitMediaGalleryByType, getSwiperMediaItems, displayLongDistance, displayShortDistance, displaySpeed, displayElapsedTime, isValidDateString, isValidTransport, hasKey, createTranslator, round2 } from './utils.js';
import { getPlaceById, fetchAPIData, getPlaceBySlug, getPlaceIdBySlug, getRouteById, getRouteIdBySlug, getPlaceIndexAlongRoute, getPlaceAlongRoute, getRouteBySlug, validatePathIds, getFetchedAPIData, getChildRoutePlaceIsAlong, getAllowedMarkers, getChildRoutes, getNextPlaceIdAlongRoute, getPathQueryString, calculatePathData, showRouteSelectModal, showOriginSelectModal, showDestinationSelectModal, showCreateNewItineraryPopup, createNewItinerary, openPaceSliderPopup, destroyRangeSliders } from './mapPlannerShared.js';
import { pathfinder } from './pathfinder.js';
import { initUserMediaUploads } from './user-media-uploads.js';
// import { getFalconWaldo, setFalconWaldo, setFalconModalContent, openFalconModal } from './falconModal.js';
import { setFenixModalContent, openFenixModal, setFenixBackdrop, closeFenixModal } from './fenixModal.js';
import { getRoutePlaces, renderFilteredPlaceList, addChildRoutePlaces, sliceRoutePlacesFromOrigin, sliceRoutePlacesToDestination, addCalculatedValuesFromOrigin, setGlobalPathStops } from './placeList.js';
import { renderMediaGallery } from './postMediaGallery.js';

const $ = window.jQuery;

// Create a translator function for the planner page.
const t = createTranslator(['planner','mapPlannerShared']);

// Initialize global vars
let stageData = [];
let maxStageId = 0;
let cachedPathData = {};
const $stagesContainer = $('[data-label="stagesContainer"]'); // Stage Container Element
let placeDataLoaded = false;

let singleStageShareModal_stageId = null;

let swiperInstances_photos = {};
let swiperInstances_videos = {};
let inflightFetchMoreRequests = {};

/**
 * Example stageData object.
 * 
 * {
        "id": 1,
        "r": 50, //route refers to the PRIMARY route of the stage.
        "dir": "r", ("f" or not set for forward, "r" for reverse)
        "o": 1,
        "d": 2,
        "via": "3,4"
    }
        And more data which is not used for pathfinding.
 */
    
/**
 * Initialize the planner page.
 */
export function initPlannerPage() {

    // Load stageData from window.ironman.stageData
    if(window.ironman.stageData) {
        stageData = window.ironman.stageData;

        // Expand names of stageData keys for frontend use.
        stageData.forEach(stage => {
            stage.route = stage.r || null;
            stage.direction = stage.dir || null;
            stage.origin = stage.o || null;
            stage.destination = stage.d || null;
            stage.transport = stage.m || 'walk'; // Default to walk if no transport is set.
            stage.metrics = {};
        });
        
        if(stageData.length === 0) {
            maxStageId = 0;
        } else {
        // Set the highest stage id to use for new stage ids.
            maxStageId = Math.max(...stageData.map(stage => stage.id));
        }
    }

    // Fetch Place API data upon pageload. Either from cache or by downloading it.
    const placeDataPromise = fetchAPIData('places', 'all', null, 'non-blocking', t('downloadingPlacesDataSpinnerMessage')).then(function() {
        return getFetchedAPIData('places').then(function() {
            // do nothing. placeData now ready to use.
        });
    });

    // This pattern allows waiting for multiple promises to resolve before running code.
    Promise.all([placeDataPromise]).then(function() {
        log('Place data loaded successfully.');
        placeDataLoaded = true;
        
        // Calculate the stages.
        // calculateStageData();
        
        // Render the planner page UI.
        renderStages();

        // Update all stages estimated time.
        updateAllStagesEstimatedTime();

        // Update the itinerary stats.
        updateItineraryStats();
    });

    // Load Map Page UI and click handlers
    initPlannerUI();

    // Allow for user media uploads on planner pages. Logged in users only.
    if(window.ironman.userData.loggedInUser) {
        initUserMediaUploads();
    }
}

/**
 * Initialize the planner page UI.
 */
export function initPlannerUI() {
    log('initPlannerUI');

    // Add jQuery click handlers to the planner page UI.
    // Use event delegation to handle clicks on dynamically added elements.
    // $stagesContainer.on("click", "li", function () {
    //     $(this).toggleClass("completed");
    // });
    

    // Create New Itinerary
    $(document).on('click', '[data-action="showCreateNewItineraryPopup"]', function (event) {
        event.preventDefault();
        log('showCreateNewItineraryPopup clicked');
        // Open the create new itinerary popup.
        showCreateNewItineraryPopup();
    });

    $(document).on('click', '[data-action="createNewItineraryModal_submit"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        
        const titleInput = $('#createNewItineraryModalContainer').find('#createNewItineraryNameInput');
        if(!titleInput.val()) {
            alert(t('createNewItineraryModal_submit_error_noTitle'));
            return false;
        }
        log('createNewItineraryModal_submit clicked');
        // Disable the button.
        $button.prop('disabled', true).addClass('disabled');
        
        // Create the new itinerary.
        const success = await createNewItinerary(titleInput.val().trim());
        if(!success) {
            // Enable the button to try again.
            $button.prop('disabled', false).removeClass('disabled');
        }
        return false;
    });

    // Browse Popular Caminos
    $(document).on('click', '[data-action="showBrowsePopularCaminosPopup"]', function (event) {
        event.preventDefault();
        log('showBrowsePopularCaminosPopup clicked');
        // Open the browse popular caminos popup.
        showBrowsePopularCaminosPopup();
    });

    $(document).on('click', '[data-action="updateItineraryPrivacy"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        const value = $button.attr('data-value');
        log('updateItineraryPrivacy clicked for value:', value);
        
        const response = await changeItineraryPrivacy(value);
        if(response.success) {
            log('Success:', response);
            // Update the dropdown item active class.
            $button.closest('[data-label="itineraryPrivacyDropdown"]').find('.dropdown-item').removeClass('active');
            $button.addClass('active');
            // Update the button icon.
            $button.closest('[data-label="itineraryPrivacyContainer"]').find('button i').addClass('d-none');
            $button.closest('[data-label="itineraryPrivacyContainer"]').find('button i[data-value="'+value+'"]').removeClass('d-none');
        } else {
            log('Error:', response.error);
        }
    });

    /**
     * Click Handler: Add a single stage to the stageData array.
     * @param {number|null|false} data-insert-after-id - The id of the stage to insert after. 
     * If null, the stage will be inserted at the end of the list. 
     * If false, the stage will be inserted at the start of the list.
     * If NaN, return false.
     */

    $(document).on('click', '[data-action="addSingleStage"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        // log('button', $button, 'data-insert-after-id', $button.attr('data-insert-after-id'));

        // Set insertAfterId. For addStage button at bottom of list, set insertAfterId to "null". Insert buttons will use closest parent stageId.
        let insertAfterId = null;
        if($button.attr('data-insert-after-id') === 'null') {
            insertAfterId = null;
        } else if($button.attr('data-insert-after-id') === 'false') {
            insertAfterId = false;
        } else {
            insertAfterId = parseInt($button.closest('[data-label="singleStageItem"]').attr('data-stage-id')) || null;
            // log('getting closes stageId', insertAfterId);
        }
        log('addSingleStage clicked for insertAfterId:', insertAfterId);

        // Validate insertAfterId
        if(insertAfterId === 'null') {
            insertAfterId = null;
        } else if(insertAfterId === 'false') {
            insertAfterId = false;
        }
        
        if(insertAfterId !== null && insertAfterId !== false) {
            insertAfterId = parseInt(insertAfterId);
            
            //If NaN, return false.
            if(isNaN(insertAfterId)) {
                log('addSingleStage: insertAfterId is not a number');
                return false;
            }

            // If the stage id does not exist, return false.
            if(!getStageData(insertAfterId)) {
                log('addSingleStage: insertAfterId does not exist', insertAfterId);
                return false;
            }
        }

        let newStageData = {
            route: null,
        };

        // Get previous stageData to assume newStageData from.
        let previousStage = null;
        if(stageData.length > 0) {
            if(insertAfterId === null) {
                // Get last stage in stageData array.
                previousStage = stageData[stageData.length - 1];
            } else if(insertAfterId === false) {
                // Do nothing. (use default data)
            } else {
                // Get previous stage by id.
                previousStage = getStageData(insertAfterId);
            }
        }

        if(previousStage) {
            if(previousStage.route) {
                newStageData.route = previousStage.route;
                if(previousStage.direction) {
                    newStageData.direction = previousStage.direction;
                }
                if(previousStage.destination) {
                    newStageData.origin = previousStage.destination;
                }
            }
            if(previousStage.transport) {
                newStageData.transport = previousStage.transport;
            }
        }
        
        // Insert a single stage to the stageData array.
        insertStageData(newStageData, insertAfterId);

        return false;
    });

    $(document).on('click', '[data-action="deleteStage"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('deleteStage clicked for stageId:', stageId);
        // Delete a single stage from the stageData array.
        deleteStage(parseInt(stageId));
        return false;
    });

    $(document).on('click', '[data-action="showSingleStageShareModal"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('showSingleStageShareModal clicked for stageId:', stageId);
        if(!stageId) {
            log('showSingleStageShareModal: Missing stage id', stageId);
            return false;
        }
        // Open the stage date modal.
        showSingleStageShareModal(parseInt(stageId));
    });

    $(document).on('click', '[data-action="openSelectTransportModePopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        if(!stageId) {
            log('Missing stage id', stageId);
            return false;
        }
        // Open the select transport mode popup.
        showSelectTransportModePopup(parseInt(stageId));
    });

    $(document).on('click', '[data-action="editTransportModeModal_submit"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        let stageId = $button.attr('data-stage-id');
        if(!stageId) {
            log('Missing stage id', stageId);
            return false;
        }
        stageId = parseInt(stageId);

        const selectedModeOfTransport = $('#singleStageItem_editModeContainer').find('[name="transportMode"]:checked').val();
        if(!selectedModeOfTransport) {
            log('Missing selected mode of transport', selectedModeOfTransport);
            return false;
        }
        // Update the stage mode of transport.
        updateStageDataValue(stageId, 'transport', selectedModeOfTransport);
        
        // Close the modal.
        closeFenixModal();
        return true;
    });

    $(document).on('click', '[data-action="openEditDatePopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        if(!stageId) {
            log('Missing stage id', stageId);
            return false;
        }
        showEditDatePopup(parseInt(stageId));
    });

    $(document).on('click', '[data-action="editDatePopup_submit"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        let stageId = $button.attr('data-stage-id');
        if(!stageId) {
            log('Missing stage id', stageId);
            return false;
        }
        stageId = parseInt(stageId);
        const stageData = getStageData(stageId);
        if(stageData === false) {
            log('Missing stage data', stageId);
            return false;
        }

        const currentDate = stageData.date ?? null;

        // First get the selected radio button value.
        const selectedRadioButton = $('#singleStageItem_editDateContainer').find('[name="camino-date"]:checked').val();
        if(selectedRadioButton === 'day-after-previous-stage') {
            // Check if this is actually a change from the current date.
            if(currentDate === null) {
                log('No change needed.');
                return false;
            } else {
                // Unset the date property from the stage data.
                updateStageDataValue(stageId, 'date', null);

                // Re-render all stages bcz the dates are sequential.
                renderStages();
            }

            // Close the modal.
            closeFenixModal();
            return true;
        } else if(selectedRadioButton === 'custom-date') {
            // Get the custom date value.
            const customDate = $('#singleStageItem_editDateContainer').find('[data-label="custom-date-input"]').val();
            if(customDate && isValidDateString(customDate)) {
                // Check if this is actually a change from the current date.
                if(currentDate === customDate) {
                    log('No change needed.');
                    return false;
                } else {
                    // Update the stage date.
                    updateStageDataValue(stageId, 'date', customDate);

                    // Re-render all stages bcz the dates are sequential.
                    renderStages();
                }

                // Close the modal.
                closeFenixModal();
                return true;
            } else {
                log('Invalid custom date', customDate);
                return false;
            }
        } else {
            log('Invalid selected radio button', selectedRadioButton);
            return false;
        }
    });

    $(document).on('click', '[data-action="openEditIntervalsPopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        if(!stageId) {
            log('Missing stage id', stageId);
            return false;
        }
        showEditIntervalsPopup(parseInt(stageId));
    });

    $(document).on('click', '[data-action="openSelectRoutePopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('editStageRoute clicked for stageId:', stageId);

        // Set already selected values
        let selectedRouteSlug = null;
        let selectedDirection = null;

        const stage = getStageData(parseInt(stageId));
        if(stage !== false) {
            if(stage.route) {
                const route = getRouteById(parseInt(stage.route));
                if(route !== false) {
                    selectedRouteSlug = route.slug;
                }
            }
            if(stage.direction && stage.direction === 'r') {
                selectedDirection = 'reverse';
            }
        }

        // Open Popup
        showRouteSelectModal(stageId, selectedRouteSlug, selectedDirection);
    });

    $(document).on('click', '[data-action="openSelectOriginPopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('openSelectOriginPopup clicked for stageId:', stageId);
        
        let routeId = null;
        let direction = null;
        let selectedOriginId = null;
        
        const stage = getStageData(parseInt(stageId));
        log('stage', stage);
        if(stage !== false) {
            if(stage.route) {
                const route = getRouteById(parseInt(stage.route));
                log('route', route);
                if(route !== false) {
                    routeId = route.id;

                    // Get already selected origin
                    if(stage.origin) {
                        selectedOriginId = parseInt(stage.origin);
                    }
                }
            }
            if(stage.direction && stage.direction === 'r') {
                direction = 'reverse';
            }
        }
        
        // Show Origin Select Modal
        if(routeId) {
            showOriginSelectModal(stageId, routeId, direction, selectedOriginId);
        } else {
            log('openSelectOriginPopup: Route not found');
            // Show a tooltip on the Select Route button to select a route first.
            const $selectRouteButton = $button.closest('[data-label="singleStageItem"]').find('[data-label="stage-route-select-link"]');
            if($selectRouteButton) {
                $selectRouteButton.addClass('border-radius-0 highlighter');
                const popover = new bootstrap.Popover($selectRouteButton, {
                    content: t('selectRouteFirstToGetStarted'),
                    placement: 'top',
                    trigger: 'manual',
                    container: '.hulk-scope',
                    customClass: 'border',
                    animation: true
                });
                popover.show();
                setTimeout(() => {
                    popover.hide();
                    $selectRouteButton.removeClass('border-radius-0 highlighter');
                }, 4000);
            }
        }
        return false;
    });

    $(document).on('click', '[data-action="openSelectDestinationPopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('openSelectDestinationPopup clicked for stageId:', stageId);
        
        let routeId = null;
        let direction = null;
        let originId = null;
        let selectedDestinationId = null;
        let selectedViaIds = [];
        
        const stage = getStageData(parseInt(stageId));
        // log('stage', stage);

        if(stage !== false) {
            if(stage.route) {
                const route = getRouteById(parseInt(stage.route));
                if(route !== false) {
                    routeId = route.id;

                    if(stage.origin) {
                        const origin = getPlaceAlongRoute(routeId, stage.origin, true);
                        if(origin !== false) {
                            originId = origin.id;

                            // Get selected destination
                            if(stage.destination) {
                                selectedDestinationId = parseInt(stage.destination);

                                if(stage.via && stage.via.length > 0 && stage.via !== 'null') {
                                    stage.via.split(',').forEach(viaId => {
                                        if(viaId) {
                                            selectedViaIds.push(parseInt(viaId));
                                        }
                                    });
                                }
                                log('selectedViaIds', stage.via, selectedViaIds);
                            }
                        } else {
                            log('openSelectDestinationPopup: Origin not found');
                            return false;
                        }
                    }
                }
            }
            if(stage.direction && stage.direction === 'r') {
                direction = 'reverse';
            }
        }
        
        // Show Destination Select Modal
        if(routeId && originId) {
            log('pre showDestinationSelectModal', stageId, routeId, direction, originId, selectedDestinationId, selectedViaIds);
            showDestinationSelectModal(stageId, routeId, direction, originId, selectedDestinationId, selectedViaIds);
        } else {
            log('openSelectDestinationPopup: Route or origin not found');
            const $selectRouteButton = $button.closest('[data-label="singleStageItem"]').find('[data-label="stage-route-select-link"]');
            if($selectRouteButton) {
                $selectRouteButton.addClass('border-radius-0 highlighter');
                const popover = new bootstrap.Popover($selectRouteButton, {
                    content: t('selectRouteFirstToGetStarted'),
                    placement: 'top',
                    trigger: 'manual',
                    container: '.hulk-scope',
                    customClass: 'border',
                    animation: true
                });
                popover.show();
                setTimeout(() => {
                    popover.hide();
                    $selectRouteButton.removeClass('border-radius-0 highlighter');
                }, 4000);
            }
        }
        return false;
    });

    $(document).on('click', '[data-action="routeSelectModal_submit"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.attr('data-stage-id');
        const selectedRouteId = $('#routeSelectModalContainer').find('input[name="routeSelect"]:checked').val();

        log('selectedRouteId', selectedRouteId);

        // Get route object
        const route = getRouteById(selectedRouteId);
        log('route', route);

        if(route) {
            let direction = null;
            // Handle direction.
            const selectedDirection = $('#routeSelectModalContainer').find('input[name="direction"]:checked').val();
            log('selectedDirection', selectedDirection);
            if(selectedDirection === 'reverse') {
                direction = 'r';
            }

            // Update route and direction locally and on server.
            updateStageDataPath(parseInt(stageId), {
                route: parseInt(route.id),
                direction: direction,
                origin: null,
                destination: null,
                via: null
            });
        }

        // Close the modal.
        closeFenixModal();

        return false;
    });

    $(document).on('click', '[data-action="originSelectModal_submit"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $('#placeSelectModalContainer').find('ul[data-label="place-list-container"]').data('stage-id') || null;

        let selectedOriginId = $button.attr('data-place-id') || null;
        if(!selectedOriginId) {
            selectedOriginId = $('#fenix').find('#placeSelectPlaceList').find('input[name="placeSelect"]:checked').val();
        }

        log('selectedOriginId', selectedOriginId, 'stage', stageId);
        
        // Get routeId from stageData.
        const stage = getStageData(parseInt(stageId));
        if(stage === false) {
            log('originSelectModal_submit: stage not found');
            return false;
        }

        const origin = getPlaceAlongRoute(stage.route, selectedOriginId, true);
        log('origin', origin);
        if(stage.route && origin) {
            // Update route and direction locally and on server.
            updateStageDataPath(parseInt(stageId), {
                route: stage.route,
                direction: stage.direction,
                origin: origin.id,
                destination: null,
                via: null
            });
        }

        // Close the modal.
        closeFenixModal();

        return false;
    });

    $(document).on('click', '[data-action="destinationSelectModal_submit"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $('#placeSelectModalContainer').find('ul[data-label="place-list-container"]').data('stage-id') || null;

        let selectedDestinationId = $button.attr('data-place-id') || null;
        if(!selectedDestinationId) {
            selectedDestinationId = $('#fenix').find('#placeSelectPlaceList').find('input[name="placeSelect"]:checked').val();
        }
        log('selectedDestinationId', selectedDestinationId, 'stage', stageId);

        let selectedViaIds = [];
        if($('#fenix').find('#placeSelectPlaceList').find('input[name="selectedChildRoutes"]:checked').length > 0) {
            $('#fenix').find('#placeSelectPlaceList').find('input[name="selectedChildRoutes"]:checked').each(function() {
                selectedViaIds.push(parseInt($(this).val()));
            });
        }

        // Get routeId and origin from stageData.
        const stage = getStageData(parseInt(stageId));
        if(stage === false) {
            log('destinationSelectModal_submit: stage not found');
            return false;
        }

        const destination = getPlaceAlongRoute(stage.route, selectedDestinationId, true);
        log('destination', destination);
        if(stage.route && stage.origin && destination) {
            // Update path locally and on server.
            // Validation is done in updateStageDataPath().
            updateStageDataPath(parseInt(stageId), {
                route: stage.route,
                direction: stage.direction,
                origin: stage.origin,
                destination: parseInt(destination.id),
                via: selectedViaIds.length > 0 ? selectedViaIds.join(',') : null
            });
        }

        // Close the modal.
        closeFenixModal();

        return false;
    });

    $(document).on('click', '[data-action="singleStageShareModal_preview"]', function (event) {
        event.preventDefault();
        singleStageShareModal_preview();
    });
    
    $(document).on('click', '[data-action="singleStageShareModal_download"]', function (event) {
        event.preventDefault();
        const previewImage = $('#singleStageShareModalDialog').find('#singleStageShareModalPreviewImage');
        if(previewImage) {
            const url = previewImage.attr('src');
            if(url) {
                const u = new URL(url);
                u.searchParams.set("download", "true"); // Bytescale: force attachment download
                u.searchParams.set("SuperCamino", "yes"); //Rename the file to SuperCamino.jpg?
                window.location.href = u.toString();
                return true;
            }
        }
        log('singleStageShareModal_download: Missing preview image url');
        return false;
    });
    
    // Turn on/off maps when switching tabs.
    $(document).on('click', '[data-action="singleStageShareModal_mapTab"]', function () {
        $('#singleStageShareModalDialog').find('#singleStageShare-miniMap').attr('checked', false);
        $('#singleStageShareModalDialog').find('#singleStageShare-routeLine').attr('checked', false);
    });
    
    // $(document).on('click', '[data-action="singleStageShareModal_photosTab"]', function () {
    //     $('#singleStageShareModalDialog').find('#singleStageShare-miniMap').attr('checked', true);
    //     $('#singleStageShareModalDialog').find('#singleStageShare-routeLine').attr('checked', true);
    // });

    // Stage Comment
    $(document).on('click', '[data-action="editStageComment"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('editStageExperience clicked for stageId:', stageId);
        // Open the comment edit modal.
        showStageCommentEditModal(stageId);
    });

    $(document).on('click', '[data-action="editStageCommentModal_submit"]', function (event) {
        event.preventDefault();
        
        const $button = $(this);
        const stageId = $button.attr('data-stage-id');
        const comment = $('#editStageCommentTextarea').val();
        log('comment', comment);

        // Update the comment.
        updateStageDataValue(stageId, 'user_comment', comment);

        // Close the modal.
        closeFenixModal();
        return false;
    });

    // Stage Private Note
    $(document).on('click', '[data-action="editStagePrivateNote"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('editStagePrivateNote clicked for stageId:', stageId);
        showStagePrivateNoteEditModal(stageId);
    });

    $(document).on('click', '[data-action="editStagePrivateNoteModal_submit"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.attr('data-stage-id');
        log('editStagePrivateNoteModal_submit clicked for stageId:', stageId);
        const privateNote = $('#editStagePrivateNoteTextarea').val();
        log('privateNote', privateNote);

        // Update the private note.
        updateStageDataValue(stageId, 'private_note', privateNote);
        
        // Close the modal.
        closeFenixModal();
        return false;
    });

    // Itinerary Name and Description
    $(document).on('click', '[data-action="editItineraryName"]', function (event) {
        event.preventDefault();

        showItineraryRenameModal();
    });

    $(document).on('click', '[data-action="editItineraryDescription"]', function (event) {
        event.preventDefault();

        // Open the description edit modal.
        showUpdateItineraryDescriptionModal();
    });

    $(document).on('click', '[data-action="renameItineraryModal_submit"]', function (event) {
        event.preventDefault();
        
        const name = $('#renameItineraryNameInput').val();
        log('name', name);
        if(name) {
            // Update the name.
            renameItinerary(name);
        }

        // Close the modal.
        closeFenixModal();
    });

    $(document).on('click', '[data-action="updateItineraryDescriptionModal_submit"]', function (event) {
        event.preventDefault();

        const description = $('#updateItineraryDescriptionTextarea').val();
        log('description', description);
        if(description) {
            // Update the description.
            updateItineraryDescription(description);
        }

        // Close the modal.
        closeFenixModal();
    });



    // Stage Timing
    $(document).on('click', '[data-action="startStageTiming"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('startStageTiming clicked for stageId:', stageId);
        
        $button.prop('disabled', true);
        try {
            await startStage(stageId);
        } catch (error) {
            log('startStageTiming error: ', error);
        } finally {
            $button.prop('disabled', false);
        }
    });

    $(document).on('click', '[data-action="pauseStageTiming"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('pauseStageTiming clicked for stageId:', stageId);
        
        $button.prop('disabled', true);
        try {
            await pauseStage(stageId);
        } catch (error) {
            log('pauseStageTiming error: ', error);
        } finally {
            $button.prop('disabled', false);
        }
    });

    $(document).on('click', '[data-action="completeStageTiming"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('completeStageTiming clicked for stageId:', stageId);
        $button.prop('disabled', true);
        try {
            await completeStage(stageId);
        } catch (error) {
            log('completeStageTiming error: ', error);
        } finally {
            $button.prop('disabled', false);
        }
    });

    $(document).on('click', '[data-action="reactivateStageTiming"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        log('reactivateStageTiming clicked for stageId:', stageId);
        $button.prop('disabled', true);
        try {
            await reactivateStage(stageId);
        } catch (error) {
            log('reactivateStageTiming error: ', error);
        } finally {
            $button.prop('disabled', false);
        }
    });

    // Single Stage Share Modal Click Handlers

    // Photo tab pane click handler.
    $(document).on('shown.bs.tab', '[data-bs-target="#photos-tab-pane"]', function () {
        log('photos-tab-pane clicked');
        // Make sure at least 4 photos are added to the swiper instance.
        // If not, fetch more photos.
        log('swiperInstances_photos', swiperInstances_photos, singleStageShareModal_stageId);
        if(swiperInstances_photos[singleStageShareModal_stageId].slides.length < 4) {
            singleStageShare_fetchAllMedia(singleStageShareModal_stageId);
        }
    });

    // Video tab pane click handler.
    $(document).on('shown.bs.tab', '[data-bs-target="#video-tab-pane"]', function () {
        log('video-tab-pane clicked');
        // Make sure at least 4 videos are added to the swiper instance.
        // If not, fetch more videos.
        if(swiperInstances_videos[singleStageShareModal_stageId].slides.length < 4) {
            singleStageShare_fetchAllMedia(singleStageShareModal_stageId);
        }
    });

    // Single Stage Details Collapse Toggle Click Handler
    $(document).on('shown.bs.collapse', '.stage-details-collapse', function () {
        log('stage-details-collapse-toggle clicked');
        const $button = $(this);
        const stageId = $button.closest('[data-label="singleStageItem"]').attr('data-stage-id');
        if(!stageId) {
            log('Missing stage id', stageId);
            return false;
        }
        renderStageDetails(stageId);
    });

    $(document).on('click', '[data-action="openPaceSliderPopup"]', function (event) {
        event.preventDefault();
        log('openPaceSliderPopup clicked');
        openPaceSliderPopup();
        return false;
    });
    
    $(document).on('click', '[data-action="paceSliderModal_submit"]', function (event) {
        event.preventDefault();
        log('paceSliderModal_submit clicked');
        const $rangeSlider = $('#paceSliderModalContainer').find('[data-label="range-slider"]');
        const paceKmh = $rangeSlider.find('[data-label="range-slider-value"]').val() ?? window.ironman.paceKmh;
        log('paceKmh', paceKmh);

        // Update the global paceKmh value.
        window.ironman.paceKmh = Number(paceKmh);

        // Destroy the range slider.
        destroyRangeSliders($rangeSlider.parent().get(0));

        // Close the modal.
        closeFenixModal();

        // Update stats
        // Todo: Does this effect itinerary stats?
        // updateItineraryStats();

        // Update all stages estimated time.
        updateAllStagesEstimatedTime();

        return false;
    });

    // Complete Itinerary Button Click Handler
    $(document).on('click', '[data-action="completeItinerary"]', async function (event) {
        event.preventDefault();
        log('completeItinerary clicked');
        const $button = $(this);
        $button.prop('disabled', true);
        try {
            const response = await changeItineraryCompleteStatus(true);
            if(response.success) {
                // Update the itineraryIsComplete global.
                window.ironman.itineraryIsComplete = true;
                log('itineraryIsComplete updated to: ', window.ironman.itineraryIsComplete);

                // Refresh UI
                renderStages(); //Needed to update UI.

                // Show the finished itinerary popup.
                showFinishedItineraryPopup();
            } else {
                log('completeItinerary response failed: ', response);
            }
        } catch (error) {
            log('completeItinerary error: ', error);
        } finally {
            $button.prop('disabled', false);
        }
        return false;
    });

    $(document).on('click', '[data-action="unCompleteItinerary"]', async function (event) {
        event.preventDefault();
        log('uncompleteItinerary clicked');
        const $button = $(this);
        $button.prop('disabled', true);
        try {
            const response = await changeItineraryCompleteStatus(false);
            if(response.success) {
                // Update the itineraryIsComplete global.
                window.ironman.itineraryIsComplete = false;
                log('itineraryIsComplete updated to: ', window.ironman.itineraryIsComplete);

                // Refresh UI
                renderStages(); //Needed to update UI.
            } else {
                log('uncompleteItinerary response failed: ', response);
            }
        } catch (error) {
            log('uncompleteItinerary error: ', error);
        } finally {
            $button.prop('disabled', false);
        }
        return false;
    });

    $(document).on('click', '[data-action="showDeleteItineraryPopup"]', function (event) {
        event.preventDefault();
        log('showDeleteItineraryPopup clicked');
        showDeleteItineraryPopup();
        return false;
    });

    $(document).on('click', '[data-action="deleteItineraryPopup_submit"]', async function (event) {
        event.preventDefault();
        log('deleteItineraryPopup_submit clicked');
        await deleteItinerary(window.ironman.itineraryId);
        return false;
    });

    $(document).on('click', '[data-action="createPopularCaminosPopup_submit"]', async function (event) {
        event.preventDefault();
        log('createPopularCaminosPopup_submit clicked');
        const $button = $(this);
        const selectedItineraryId = $('#browsePopularCaminosPopupContainer').find('input[name="itinerarySelect"]:checked').val();
        if(!selectedItineraryId) {
            log('No itinerary selected');
            return false;
        }
        $button.prop('disabled', true);
        try {
            const response = await duplicateItinerary(selectedItineraryId);
            if(response.success) {
                updateLoadingSpinner('redirecting-to-new-itinerary', true, 'page-blocking', t('redirectingToNewCaminoSpinnerMessage'));
                // Redirect to the new itinerary page.
                log('Redirecting to new itinerary page', response.data.new_post_id);
                window.location.href = response.data.new_itinerary_url ?? '/members/'+window.ironman.userData.username+'/caminos/';
                // Close the modal.
                closeFenixModal();
            } else {
                log('Error duplicating itinerary: ', response);
                $button.prop('disabled', false);
            }
        } catch (error) {
            log('createPopularCaminosPopup_submit error: ', error);
            $button.prop('disabled', false);
        } finally {
            
        }
        return false;
    });

    $(document).on('click', '[data-action="duplicateItinerary"]', async function (event) {
        event.preventDefault();
        log('duplicateCamino clicked');
        try {
            const response = await duplicateItinerary(window.ironman.itineraryId);
            if(response.success) {
                // Redirect to the new itinerary page.
                log('Redirecting to new camino page', response.data.new_post_id);
                window.location.href = response.data.new_itinerary_url ?? '/members/'+window.ironman.userData.username+'/caminos/';
            } else {
                log('Error duplicating camino: ', response);
            }
        } catch (error) {
            log('duplicateCamino error: ', error);
        }
        return false;
    });

    $(document).on('click', '[data-action="filterSharedCaminos"]', function (event) {
        event.preventDefault();
        log('filterSharedCaminos clicked');
        filterSharedCaminos_click_change_handler();
    });
    $(document).on('change', '[data-action="filterSharedCaminos_select"]', function (event) {
        event.preventDefault();
        log('filterSharedCaminos_select changed');
        filterSharedCaminos_click_change_handler();
    });

}

async function showItineraryRenameModal() {
    log('showItineraryRenameModal');
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('renameItineraryModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'renameItinerary'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('Save')).attr('data-action', 'renameItineraryModal_submit');

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('renameItineraryModalTemplate');
    
    // Start customizing the modal body...
    modalBody.find('#renameItineraryNameInput').val(window.ironman.itineraryData.name);
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

async function showUpdateItineraryDescriptionModal() {
    log('showUpdateItineraryDescriptionModal');
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('updateItineraryDescriptionModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'updateItineraryDescription'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('Save')).attr('data-action', 'updateItineraryDescriptionModal_submit');

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('updateItineraryDescriptionModalTemplate');
    
    // Start customizing the modal body...
    modalBody.find('#updateItineraryDescriptionTextarea').val(window.ironman.itineraryData.description);
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

/**
 * Get the index of a stage in the stageData array.
 * @param {string} stageId - The id of the stage to get the index of.
 * @returns {number|false} The index of the stage or false if not found.
 */
function getStageIndexById(stageId) {
    const stageIndex = stageData.findIndex(s => s.id === parseInt(stageId));
    if (stageIndex === -1) {
        return false;
    }
    return stageIndex;
}

/**
 * Get the date of a stage by its id.
 * @param {string} stageId - The id of the stage to get the date of.
 * @returns {string} The date of the stage (YYYY-MM-DD)
 */
function getStageDateById(stageId) {
    // Start with the itinerary created_at date.
    let date = window.ironman.itineraryData.created_at;
    let addDays = 0;

    // Loop through the stageData array, update the date whenever it's found, otherwise +1 day to the current value.
    for (let index = 0; index < window.ironman.stageData.length; index++) {
        const stage = window.ironman.stageData[index];

        // If this stage has a date, use it and reset addDays to 0.
        if(stage.date && isValidDateString(stage.date)) {
            date = stage.date;
            addDays = 0;
        } else {
            // Otherwise, add 1 day to addDays count (unless the stage is the first stage, in which case use the itinerary created_at date).
            if(index > 0) {
                addDays++;
            }
        }

        // If this stage is the one we're looking for, stop looping and return the date.
        if(stage.id === parseInt(stageId)) {
            break;
        }
    }

    // Add the addDays to the date and return the result as YYYY-MM-DD.
    const d = new Date(date);
    d.setDate(d.getDate() + addDays);
    return d.toISOString().split('T')[0]; // Return the date as YYYY-MM-DD.
}

/**
 * Get the path data for a single stage.
 * For a single stage, calculate metrics or get cached data.
 * @param {string} stageId - The id of the stage to get the path data for.
 * @returns {Object|false} The path data for the stage or false if not found.
 */
function getSingleStagePathData(stageId) {
    log('getSingleStagePathData');
    
    // Get the stage data.
    const stage = getStageData(stageId);
    if (!stage) {
        return false;
    }

    // Requires at least route, origin, and destination to continue.
    if(!stage.route || !stage.origin || !stage.destination) {
        return null;
    }
    
    // Sanitize the stage data into a pathParams object.
    const pathParams = {
        route: stage.route ? parseInt(stage.route) : null,
        direction: (stage.direction && stage.direction === 'r') ? 'reverse' : 'forward',
        origin: stage.origin ? parseInt(stage.origin) : null,
        destination: stage.destination ? parseInt(stage.destination) : null,
        viaArray: [],
        via: null
    }
    if (stage.via && stage.via.length > 0) {
        pathParams.viaArray = stage.via.split(',').map(id => parseInt(id));
        if(pathParams.viaArray.length > 0) {
            pathParams.via = pathParams.viaArray.join(',');
        }
    }
    // Get path query string to use as the key for the cachedPathData object.
    const pathQueryString = getPathQueryString(pathParams);
    if(cachedPathData[pathQueryString]) {
        // Path data is already cached, so use it.
        return cachedPathData[pathQueryString];
    } else {
        // Path data is not cached, so calculate it.

        // Should have been validated before being saved to stageData.

        // Get the path segments from pathfinder.
        // NOTE: pathfinder via expects [] of routeIds.
        const pathSegments = pathfinder(pathParams.route, pathParams.direction, pathParams.origin, pathParams.destination, pathParams.viaArray);
        
        // Calculate the path data
        const pathData = calculatePathData(pathSegments);
        
        // Save the data to the cachedPathData object for next time.
        cachedPathData[pathQueryString] = {
            pathSegments: pathSegments,
            pathData: pathData
        }
        
        // Return the path data.
        return {
            pathSegments: pathSegments,
            pathData: pathData
        }
    }
}

// Stage Data Helper Functions
// These functions are used to manage the stageData array.
// They are used to insert, update, and delete stage data objects.
// They also save the stage data to the backend.

/**
 * Get the stage data for a single stage.
 * @param {string} stageId - The id of the stage to get the data for.
 * @returns {Object|false} The stage data or false if not found.
 */
function getStageData(stageId) {
    const stage = stageData.find(s => s.id === stageId);
    if (!stage) return false;
    return stage;
}
// window.getStageData = getStageData;

function setStageData(stageId, key, value) {
    const stageIndex = getStageIndexById(stageId);
    if (stageIndex === false) {
        return false;
    }
    stageData[stageIndex][key] = value;
    return true;
}

function setStageMetric(stageId, metricKey, value) {
    const stageIndex = getStageIndexById(stageId);
    if (stageIndex === false) {
        return false;
    }
    // Create the metrics object if it doesn't exist.
    if(!stageData[stageIndex].metrics) {
        stageData[stageIndex].metrics = {};
    }
    stageData[stageIndex].metrics[metricKey] = value;
    return true;
}

function unsetStageDataKey(stageId, keyToUnset) {
    const stageIndex = getStageIndexById(stageId);
    if (stageIndex === false) {
        return false;
    }
    delete stageData[stageIndex][keyToUnset];
    return true;
}

/**
 * Insert a stage data object into the stageData array.
 * @param {Object} stageValues - The stage data object to insert.
 * @param {number|null|false} insertAfterId - The id of the stage to insert after. If null, the stage will be added to the end of the array. If false, the stage will be added to the start of the array. 
*/
//Example usage:
// insertStageData({
//     route: 50, //Always a primary route. It will find the origin/destination on the child routes if necessary.
//     origin: 1509,
//     destination: 1646,
//     via: '88' //Optional. CSV STRING of child route ids. Must be string to pass validation.
// });
// insertStageData({
//     route: 50, //Always a primary route.
//     origin: 1514,
//     destination: 1646
// });
function insertStageData(stageValues, insertAfterId=null) {
    log('insertStageData', stageValues, insertAfterId);

    // Validate the stage path data.
    const newStage = validatePathIds(stageValues);

    // Validate non-path data
    // Validate transport (unless it's the default value of 'walk')
    if(hasKey(stageValues, 'transport') && stageValues.transport !== 'walk' && hasKey(window.ironman.appConfig.modesOfTransport, stageValues.transport)) {
        newStage.transport = stageValues.transport;
    }
    
    // Get the next stage id.
    const nextStageId = maxStageId + 1;

    // Assign the stage id to the stage values.
    newStage.id = nextStageId;

    // Update the max stage id for the next time we insert a stage.
    maxStageId = nextStageId;
    
    // Insert the stage data into the stageData array.
    if(insertAfterId === null) {
        // Insert at the end of the array.
        stageData.push(newStage);
    } else if(insertAfterId === false) {
        // Insert at the beginning of the array.
        stageData.unshift(newStage);
    } else {
        // Get the index of the stage to insert after.
        const insertIndex = getStageIndexById(insertAfterId);
        log('inserting stage at insertIndex: ', insertIndex+1);
        if(insertIndex === false) {
            log('insertStageData: stage index not found');
            return false;
        }
        stageData.splice((insertIndex+1), 0, newStage);
    }

    log('rendering stages');
    // Update the stage data in the DOM.
    renderStages();

    // Update the itinerary stats.
    updateItineraryStats();

    // Add index to validatedStage object for use in saveStageDataToServer.
    // Send as strings to avoid transport issues.
    newStage.insert_after_id = insertAfterId === null ? 'null' : (insertAfterId === false ? 'false' : parseInt(insertAfterId));

    // Save the stage data to the backend.
    // No need to run async because we don't care about the response.
    saveStageDataToServer(newStage.id, 'saveItineraryStagePath', newStage, 'non-blocking', t('addingStageSpinnerMessage'));
}


/**
 * Validate a stage data object then update it in the stageData array and on the server.
 * @param {string} stageId - The id of the stage to update.
 * @param {Object} stageValues - The new values to update the stage with.
 * @param {string} spinnerType - The type of spinner to show.
 * @param {string} spinnerMessage - The message to show in the spinner.
 * @returns {boolean} True if the stage was updated successfully, false otherwise.
 */
async function updateStageDataPath(stageId, stageValues, spinnerType='non-blocking', spinnerMessage=t('updatingStageSpinnerMessage')) {
    log('updateStageDataPath', stageId, stageValues);

    // Get the existing stage data.
    const stage = getStageData(stageId);
    if (!stage) {
        log('updateStageDataPath', stageId, 'not found');
        return false;
    }

    // Validate the new stageValues
    let validatedPath = validatePathIds(stageValues);
    log('validatedPath', validatedPath);
    
    // Merge the new values with the existing stage data. Overwrites existing path values.
    Object.assign(stage, validatedPath);

    // Update the stage data in the stageData array.
    const stageIndex = getStageIndexById(stageId);
    if (stageIndex === false) {
        return false;
    }
    stageData[stageIndex] = stage;

    // Set pathChanged update flag to let the UI know what it needs to re-render.
    setStageData(stageId, 'pathChanged', true);

    // Update the stage data in the DOM.
    updateSingleStageRender(stageId);

    // Update the itinerary stats.
    updateItineraryStats();

    // Save the stage data to the backend.
    const response = await saveStageDataToServer(stage.id, 'saveItineraryStagePath', validatedPath, spinnerType, spinnerMessage);
    if(response.success) {
        return true;
    } else {
        return false;
    }
}

/**
 * Update a single value in the stage data object.
 * @param {string} stageId - The id of the stage to update.
 * @param {string} key - The key of the value to update.
 * @param {string} value - The value to update the stage with.
 */
async function updateStageDataValue(stageId, key, value, spinnerType='non-blocking', spinnerMessage=t('updatingStageSpinnerMessage')) {
    const stageIndex = getStageIndexById(stageId);
    if (stageIndex === false) {
        return false;
    }

    // Valid keys
    const validKeys = ['date', 'timing', 'user_comment', 'private_note', 'transport'];
    if(!validKeys.includes(key)) {
        return false;
    }

    let ajaxAction = null;
    let payloadKey = key;

    // Handle key specific updates.
    if(key === 'date') {
        ajaxAction = 'updateStageDate';
        payloadKey = 'stage_date';
        // setStageData(stageId, 'otherChanged', true);
    } else if(key === 'transport') {
        ajaxAction = 'updateStageModeOfTransport';
        payloadKey = 'mode_of_transport';
        setStageData(stageId, 'otherChanged', true);
    } else if(key === 'timing') {
        ajaxAction = 'updateStageTiming';
        payloadKey = 'timing';
        setStageData(stageId, 'timingChanged', true);
    } else if(key === 'user_comment') {
        ajaxAction = 'updateStageComment';
        payloadKey = 'text';
        setStageData(stageId, 'textChanged', true);
    } else if(key === 'private_note') {
        ajaxAction = 'updateStagePrivateNote';
        payloadKey = 'text';
        setStageData(stageId, 'textChanged', true);
    }

    // Set payload.
    const payload = {
        [payloadKey]: value
    };

    // Update the stage data in the local stageData array.
    setStageData(stageId, key, value);

    // Update the stage render
    updateSingleStageRender(stageId);

    // Update the stage data on the backend.
    const response = await saveStageDataToServer(stageId, ajaxAction, payload, spinnerType, spinnerMessage);
    if(response.success) {
        return true;
    } else {
        return false;
    }
}

/**
 * Delete a stage data object from the stageData array.
 * @param {string} stageId - The id of the stage to delete.
 */
async function deleteStage(stageId) {
    const stageIndex = getStageIndexById(stageId);
    if (stageIndex === false) {
        return false;
    }
    // Remove the stage from the stageData array.
    stageData.splice(stageIndex, 1);

    // Update the stage data in the DOM.
    renderStages();

    // Delay to match animation duration, then update the itinerary stats.
    setTimeout(function() {
        updateItineraryStats();
    }, 600);

    // Delete the stage data from the backend.
    const response = await saveStageDataToServer(stageId, 'deleteItineraryStage');
    if(response.success) {
        if(response.data.responseData.media_gallery_counts && response.data.responseData.media_gallery) {
            window.ironman.postMediaGalleryCounts = response.data.responseData.media_gallery_counts;
            window.ironman.postMediaGallery = response.data.responseData.media_gallery;
            
            // Update the media gallery for "root" gallery.
            renderMediaGallery('root');
        }
    }
    
}

/**
 * Start a stage.
 * @param {string} stageId - The id of the stage to start.
 */
async function startStage(stageId) {
    const response = await saveStageDataToServer(stageId, 'startStage', {}, 'non-blocking', t('startingStageSpinnerMessage'));
    if(response.success) {
        // Update local stageData array.
        setStageData(stageId, 'status', response.data.responseData.status);
        setStageData(stageId, 'timing', response.data.responseData.timing);
        
        // Set the timingChanged flag to true.
        setStageData(stageId, 'timingChanged', true);

        // Refresh UI
        renderStages(); //Needed to update frame.

        // Update the itinerary stats.
        updateItineraryStats();
    } else {
        // Handled in click handler
    }

    return response;
}
// window.startStage = startStage;

/**
 * Pause a stage.
 * @param {string} stageId - The id of the stage to pause.
 */
async function pauseStage(stageId) {
    
    const response = await saveStageDataToServer(stageId, 'pauseStage', {}, 'non-blocking', t('pausingStageSpinnerMessage'));
    if(response.success) {
        // Update local stageData array.
        setStageData(stageId, 'status', response.data.responseData.status);
        setStageData(stageId, 'timing', response.data.responseData.timing);

        // Set the timingChanged flag to true.
        setStageData(stageId, 'timingChanged', true);
        
        // Refresh UI
        renderStages(); //Needed to update frame.

        // Update the itinerary stats.
        updateItineraryStats();
    } else {
        // Handled in click handler
    }

    return response;
}
// window.pauseStage = pauseStage;

/**
 * Complete a stage.
 * @param {string} stageId - The id of the stage to complete.
 */
async function completeStage(stageId) {
    const response = await saveStageDataToServer(stageId, 'completeStage', {}, 'non-blocking', t('completingStageSpinnerMessage'));
    if(response.success) {
        // Update local stageData array.
        setStageData(stageId, 'status', response.data.responseData.status);
        setStageData(stageId, 'timing', response.data.responseData.timing);

        // Set the timingChanged flag to true.
        setStageData(stageId, 'timingChanged', true);
        
        // Refresh UI
        renderStages(); //Needed to update frame.

        // Update the itinerary stats.
        updateItineraryStats();

        // Show Finished Stage popup.
        showFinishedStagePopup(stageId);
    } else {
        // Handled in click handler
    }

    return response;
}

/**
 * Reactivate a stage.
 * @param {string} stageId - The id of the stage to reactivate.
 */
async function reactivateStage(stageId) {
    const response = await saveStageDataToServer(stageId, 'reactivateStage');
    if(response.success) {
        // Update local stageData array.
        if(response.data.responseData.status && response.data.responseData.status !== 'null') {
            setStageData(stageId, 'status', response.data.responseData.status);
        } else {
            unsetStageDataKey(stageId, 'status');
        }
        
        // Set the statusChanged flag to true.
        setStageData(stageId, 'statusChanged', true);

        // Refresh UI
        renderStages(); //Needed to update frame.

        // Update the itinerary stats.
        updateItineraryStats();
    } else {
        // Handled in click handler
    }

    return response;
}

/**
 * Save the stage data to the backend.
 * @param {string} stageId - The id of the stage to update.
 * @param {string} action - The action to perform on the stage.
 * @param {Object} data - The data to update the stage with.
 */
async function saveStageDataToServer(stageId, action, stageValues={}, spinnerType='non-blocking', spinnerMessage=null) {
    
    const payload = {
        stage_id: stageId,
        action: action,
        ...stageValues,
        itinerary_id: window.ironman.itineraryId,
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce
    };
    log('saveStageDataToServer', payload);

    // Call the admin ajax function. Returns a promise that resolves with the response from the endpoint.
    return callAdminAjax('saveStageData', payload, 'saveStageData-'+action+'-'+stageId, null, spinnerType, spinnerMessage);
}

/**
 * Render the planner page UI.
 */
function renderStages() {
    log('renderStages');
    
    // Wait for placeData to be loaded before rendering the stages.
    if(!placeDataLoaded) {
        return;
    }

    // Initialize the existingIds object to hold DOM elements by stageId.
    // Any existingId which is not in stageData will be removed from the DOM.
    const existingIds = {};
  
    // Populate the existingIds object with the DOM elements of the existing stages. Ignore the template.
    $stagesContainer.find('[data-label="singleStageItem"]').each(function () {
        const id = $(this).attr("data-stage-id");
        existingIds[id] = this; // store DOM element
    });
  
    // Loop through the stageData and set frames WITHOUT altering stageData array.
    let has_framed_stage = false;
    let active_stages = [];
    let paused_stages = [];
    let not_started_stages = [];
    let complete_stages = [];
    let first_not_completed_stage_index = null;
    stageData.forEach((stage, index) => {
        if(stage.status === 'complete') {
            complete_stages.push(index);
        } else if(stage.status === 'active') {
            active_stages.push(index);
            has_framed_stage = true;
        } else if(stage.status === 'paused') {
            paused_stages.push(index);
            has_framed_stage = true;
        }
        if(first_not_completed_stage_index === null && stage.status !== 'complete') {
            first_not_completed_stage_index = index;
            log('first not completed stage index: ', first_not_completed_stage_index);
        }
    });
    // If no framed stages, add a not started frame to the first stage THAT ISN'T COLLAPSED (Completed)
    if(!has_framed_stage && first_not_completed_stage_index !== null) {
        not_started_stages.push(first_not_completed_stage_index);
    }

    // Show/hide the complete itinerary button. (If not already complete)
    // log('Show/Hide Complete Itinerary Button: complete_stages.length: ', complete_stages.length, ' stageData.length: ', stageData.length);
    const $itineraryButtonsContainer = $('#itinerary-buttons-container');
    if((complete_stages.length === stageData.length) && (stageData.length > 0) && (window.ironman.itineraryIsComplete === false)) {
        $itineraryButtonsContainer.find('[data-label="completeItineraryButton"]').removeClass('d-none');
    } else {
        $itineraryButtonsContainer.find('[data-label="completeItineraryButton"]').addClass('d-none');
    }

    // Show/hide the uncomplete itinerary button.
    const $itineraryToolsContainer = $('#itinerary-tools-container');
    if(window.ironman.itineraryIsComplete === true) {
        $itineraryToolsContainer.find('[data-label="unCompleteItineraryButton"]').removeClass('d-none');
    } else {
        $itineraryToolsContainer.find('[data-label="unCompleteItineraryButton"]').addClass('d-none');
    }

    // Loop through the stageData and render the stages.
    stageData.forEach((stage, index) => {
        let $li = $stagesContainer.find(`[data-label="singleStageItem"][data-stage-id="${stage.id}"]`);
        log('rendering stage: ', stage.id, ' at index: ', index);

        if ($li.length === 0) {
            // Item does not exist, create it
            $li = createSingleStageRender(stage.id);
            log('createSingleStageRender', stage.id, $li);

            // Make $li invisible so it can fade in.
            $li.hide();

            // Insert at correct position
            if (index === 0) {
                $stagesContainer.prepend($li);
            } else {
                // insert after previous stage
                const prevId = stageData[index-1].id;
                log('insert after previous stage with ID: ', prevId);
                $stagesContainer.find(`[data-label="singleStageItem"][data-stage-id="${prevId}"]`).after($li);
            }

            // Now update the new render with the stage data and fade it in.
            $li = updateSingleStageRender(stage.id).fadeIn(600);
            log('update NEW SingleStageRender', stage.id, $li);
            
        } else {
            // Item exists, update it
            $li = updateSingleStageRender(stage.id);
            log('updating EXISTING SingleStageRender', stage.id, $li);
            delete existingIds[stage.id]; // remove from existingIds object so it isn't deleted in the next step.
        }

        // --------- HANDLE FRAMES ----------
        // Add/Remove Frame (header and footer) if needed.
        const $cardContainer = $li.find('[data-label="card-container"]');
        const currentFrame = $cardContainer.attr('data-card-frame') || false;
        let newFrame = false;

        if(complete_stages.includes(index) || active_stages.includes(index) || paused_stages.includes(index) || not_started_stages.includes(index)) {
            // Set new frame.
            if(complete_stages.includes(index)) {
                newFrame = 'complete';
            } else if(active_stages.includes(index)) {
                newFrame = 'active';
            } else if(paused_stages.includes(index)) {
                newFrame = 'paused';
            } else if(not_started_stages.includes(index)) {
                newFrame = 'not-started';
            }
            log('new frame: ', newFrame, ' for stage: ', stage.id);
        }

        // Check if change is needed
        if(currentFrame !== newFrame) {
            log('changing frame from: ', currentFrame, ' to: ', newFrame);
            
            // Remove previous frame
            log('removing frame');
            $cardContainer
                .removeClass('card-hover card-hover-overlay-none border-0 bg-body-secondary p-1 bg-gradient-success')
                .removeAttr('data-card-frame');
            $cardContainer.find('[data-label="frame-footer"]').remove();
            let newClass = '';

            if(newFrame === false) {
                newClass = 'card-hover card-hover-overlay-none';
            } else {
                // Add frame
                log('adding frame');
                $cardContainer.attr('data-card-frame', newFrame);

                // Add frame header/footer.
                let frameFooterTemplate = false;
                if(newFrame === 'complete') {
                    newClass = 'border-0 bg-body-secondary p-1';
                    frameFooterTemplate = getTemplate('singleStageItem_completeFrameFooterTemplate');
                } else if(newFrame === 'active') {
                    newClass = 'border-0 bg-gradient-success p-1';
                    frameFooterTemplate = getTemplate('singleStageItem_activeFrameFooterTemplate');
                } else if(newFrame === 'paused') {
                    newClass = 'border-0 bg-body-secondary p-1';
                    frameFooterTemplate = getTemplate('singleStageItem_pausedFrameFooterTemplate');
                } else if(newFrame === 'not-started') {
                    newClass = 'border-0 bg-body-secondary p-1';
                    frameFooterTemplate = getTemplate('singleStageItem_notStartedFrameFooterTemplate');
                } else {
                    log('updateSingleStageRender: unknown frame type', newFrame);
                    return false;
                }

                if(frameFooterTemplate) {
                    log('adding frame footer: ', frameFooterTemplate);
                    const $frameFooter = frameFooterTemplate.clone();

                    // Add the new frame
                    $cardContainer.addClass(newClass);
                    $cardContainer.append($frameFooter);
                }
            }
        }

        // Any time there's a frame, even if it hasn't changed. E.g. on the pageload.
        if(newFrame !== false) {
            // Update elapsed seconds from stage metrics
            let elapsedSeconds = stage.metrics.elapsedSeconds;
            if((elapsedSeconds && parseInt(elapsedSeconds) > 0) || newFrame === 'active') {
                // Active frame always shows a timer even if it's 0.
                elapsedSeconds = parseInt(elapsedSeconds) || 0;
                $cardContainer.find('[data-label="stage-timing-elapsed"]').text(displayElapsedTime(elapsedSeconds));
            } else {
                $cardContainer.find('[data-label="stage-timing-elapsed"]').text('');
            }
        }
    });
  
    // Remove any items remaining in the existingIds object. These are stages that were not in the new data.
    for (const id in existingIds) {
        // Add .deleting to let stats know not to include it in the calculations.
        // Fade it out and then remove it.
        $(existingIds[id]).addClass('deleting').fadeOut(600, function() {
            $(this).remove(); // Remove the DOM element.
        });
    }

}

/**
 * Create a single stage render.
 * @param {Object} stage - The stage object to create a render for.
 * @returns {Object} The rendered stage.
 */
function createSingleStageRender(stageId) {
    log('creating single stage render', stageId);
    // Get the blank stage template
    const blankStageTemplate = getTemplate('singleStageItemTemplate');
    let $li = blankStageTemplate.clone();
    
    // Set the data-id attribute.
    $li.attr('data-stage-id', stageId);

    // Wire up collapse toggle and collapse content.
    $li.find('[data-label="stage-details-collapse"]').attr('id', 'collapse-stage-details_'+stageId);
    $li.find('[data-label="stage-details-collapse-toggle"]').attr('data-bs-target', '#collapse-stage-details_'+stageId);
    
    log('created single stage render', stageId, $li);
    
    return $li;
}

/**
 * Update a single stage render.
 * @param {string} stageId - The id of the stage to update.
 * Function only requires the id of the stage to update. It will fetch the data from stageData.
 */
function updateSingleStageRender(stageId) {
    log('updateSingleStageRender', stageId, parseInt(stageId));
    // Get the stage data.
    const stage = getStageData(parseInt(stageId));
    if (stage === false) {
        log('updateSingleStageRender', stageId, 'stage not found');
        return false;
    }

    const hasPathChange = stage.pathChanged ?? true; // True for first render.
    const hasTimingChange = stage.timingChanged ?? true;
    const hasTextChange = stage.textChanged ?? true;
    const hasOtherChange = stage.otherChanged ?? true;

    // Reset flags to false.
    setStageData(stageId, 'pathChanged', false);
    setStageData(stageId, 'timingChanged', false);
    setStageData(stageId, 'textChanged', false);
    setStageData(stageId, 'otherChanged', false);

    // Get the render.
    const $li = $stagesContainer.find(`[data-label="singleStageItem"][data-stage-id="${stageId}"]`);
    if($li.length > 0) {
        log('updateSingleStageRender', stageId, $li);
    } else {
        log('updateSingleStageRender', stageId, 'existing render not found');
        return null;
    }

    // If the path has changed, update the data that is based on the path. (So we can safely leave it alone if no change)
    if(hasPathChange) {
        log('Re-rendering Path', stageId);

        let origin = false;
        let destination = false;
        let pathData = null;
        let mapLink = '/map/';

        // Get route
        const route = getRouteById(stage.route);
        if(route !== false) {
            mapLink += '?route='+route.slug;

            // Get Direction
            if(stage.direction === 'r') {
                mapLink += '&direction=reverse';
            }

            // Get Origin
            origin = getPlaceById(stage.origin);
            if(origin !== false) {
                mapLink += '&origin='+origin.slug;

                // Get Destination
                destination = getPlaceById(stage.destination);
                if(destination !== false) {
                    mapLink += '&destination='+destination.slug;

                    // Get the path data for the stage.
                    pathData = getSingleStagePathData(stage.id);
                    log('pathData', pathData);
                    if(pathData && pathData.pathData) {
                        // Save pathData to the stage data to use later.
                        setStageData(stage.id, 'pathData', pathData.pathData);
                    } else {
                        // Stage data is invalid, so hide the render. Shouldn't happen.
                        log('Stage data is invalid', stage.id);
                    }

                    // Get VIAS
                    let vias = [];
                    // marge arrays pathData.requiredVias and pathData.selectedVias if set
                    if(stage.pathData?.requiredVias) {
                        vias = [...vias, ...stage.pathData.requiredVias];
                    }
                    if(stage.pathData?.selectedVias) {
                        vias = [...vias, ...stage.pathData.selectedVias];
                    }
                    log('vias', vias);
                    // Remove duplicates
                    vias = vias.filter((via, index, self) => self.indexOf(via) === index);
                    
                    // Loop through vias and get the route slug for each via route id
                    const viaSlugs = [];
                    vias.forEach(via => {
                        const viaRoute = getRouteById(via);
                        log('viaRoute', viaRoute);
                        if(viaRoute) {
                            viaSlugs.push(viaRoute.slug);
                        }
                    });

                    // Join via slugs with commas
                    if(viaSlugs.length > 0) {
                        const viaSlugsString = viaSlugs.join(',');
                        mapLink += '&via='+viaSlugsString;
                    }
                }
            }
        }
        // const via = stage.via.split(',').map(id => getPlaceById(id));
        // $li.find('[data-label="stage-via"]').text(stage.via);
        
        // Update Map Link
        $li.find('[data-label="showOnMapLink"]').attr('href', mapLink);

        if(route) {
            log('route found:', route);
            const routeName = window.ironman.appConfig.routeTaxonomy[route.slug]?.name ?? route.text;
            $li.find('[data-label="stage-route-name"]').text(routeName);
            $li.find('[data-label="stage-route-icon"]').attr('src', window.ironman.appConfig.primaryRoutes[route.id].icon).attr('alt', routeName);
            $li.find('[data-label="stage-route-link"]').attr('href', '/camino/'+route.slug+'/').removeClass('d-none');
            $li.find('[data-label="stage-route-select-link"]').addClass('d-none');
            $li.find('[data-label="stage-route-edit-button"]').removeClass('d-none');
        } else {
            $li.find('[data-label="stage-route-name"]').text('');
            $li.find('[data-label="stage-route-icon"]').attr('src', '');
            $li.find('[data-label="stage-route-link"]').attr('href', '#').addClass('d-none');
            $li.find('[data-label="stage-route-select-link"]').removeClass('d-none');
            $li.find('[data-label="stage-route-edit-button"]').addClass('d-none');
        }
        // $li.find('[data-label="stage-route-via"]').text(stage.via);
        if(stage.dir && stage.dir === 'r') {
            $li.find('[data-label="stage-direction"]').text('Reverse');
        } else {
            // Do nothing.
        }
        if(origin) {
            log('origin', origin);
            $li.find('[data-label="stage-origin-title"]').text(origin.text).attr('href', '/place/'+origin.slug+'/').removeClass('d-none');
            $li.find('[data-label="stage-origin-select-link"]').addClass('d-none');
            $li.find('[data-label="stage-origin-edit-button"]').removeClass('d-none');
        } else {
            $li.find('[data-label="stage-origin-title"]').text('').attr('href', '#').addClass('d-none');
            $li.find('[data-label="stage-origin-select-link"]').removeClass('d-none');
            $li.find('[data-label="stage-origin-edit-button"]').addClass('d-none');
        }
        if(destination) {
            $li.find('[data-label="stage-destination-title"]').text(destination.text).attr('href', '/place/'+destination.slug+'/').removeClass('d-none');
            $li.find('[data-label="stage-destination-select-link"]').addClass('d-none');
            $li.find('[data-label="stage-destination-edit-button"]').removeClass('d-none');
            
            if(pathData) {
                // Set Stage Metric values for use in itinerary stats.
                setStageMetric(stageId, 'distance', pathData.pathData.distance || 0);
                setStageMetric(stageId, 'ascent', pathData.pathData.ascent || 0);
                setStageMetric(stageId, 'descent', pathData.pathData.descent || 0);
                // log('stageData',stageData);

                // Update single stage UI metrics
                $li.find('[data-label="stage-distance"]').text(pathData ? displayLongDistance(pathData.pathData.distance) : '');
                $li.find('[data-label="stage-ascent"]').text(pathData ? displayShortDistance(pathData.pathData.ascent) : '');
                $li.find('[data-label="stage-descent"]').text(pathData ? displayShortDistance(pathData.pathData.descent) : '');

            } else {
                // Shouldn't happen
    
            }
        } else {
            $li.find('[data-label="stage-destination-title"]').text('').attr('href', '#').addClass('d-none');
            $li.find('[data-label="stage-destination-select-link"]').removeClass('d-none');
            $li.find('[data-label="stage-destination-edit-button"]').addClass('d-none');
    
            // Zero out metrics for single stage UI metrics.
            $li.find('[data-label="stage-distance"]').text('');
            $li.find('[data-label="stage-ascent"]').text('');
            $li.find('[data-label="stage-descent"]').text('');
    
            // Zero out metrics for itinerary UI metrics.
            setStageMetric(stageId, 'distance', 0);
            setStageMetric(stageId, 'ascent', 0);
            setStageMetric(stageId, 'descent', 0);

        }


        // Invalidate Stage Details Cache (if path has changed)
        $li.data('detailsLoaded', false);
        maybeRenderStageDetails(stageId); // Update the stage details IF it's currently open.
    }

    if(hasTextChange) {
        if(stage.user_comment && stage.user_comment.length > 0) {
            $li.find('[data-label="stage-user-comment"]').text(stage.user_comment);
            $li.find('[data-label="stage-user-comment-add-link"]').addClass('d-none');
        } else {
            $li.find('[data-label="stage-user-comment"]').text('');
            $li.find('[data-label="stage-user-comment-add-link"]').removeClass('d-none');
        }
        if(stage.private_note && stage.private_note.length > 0) {
            $li.find('[data-label="stage-private-note"]').text(stage.private_note);
        } else {
            $li.find('[data-label="stage-private-note"]').html('<a href="#" class="text-body-tertiary" data-action="editStagePrivateNote"><i class="ci-pencil-simple-line me-1"></i>Add a private note...</a>');
        }
    }

    // Handle Stage Timing
    if(hasTimingChange) {
        log('stage.timing', stage, typeof stage.timing);
        if((typeof stage.timing === 'object') && stage.timing !== null && Object.keys(stage.timing).length > 0) {
            // Add all the segments of the timing array together.
            let totalTiming = 0;
            Object.values(stage.timing).forEach(segment => {
                let start = 0;
                let stop = 0;
                if(segment.hasOwnProperty('start')) {
                    start = parseInt(segment.start);
                }
                if(segment.hasOwnProperty('stop')) {
                    stop = parseInt(segment.stop);
                } else {
                    // Set stop to current UTC minutes since epoch timestamp
                    stop = Math.floor(Date.now() / 1000);
                }
                if(stop > start) {
                    totalTiming += (stop - start);
                }
            });

            // Save to data attribute for later use in Frame Footer Template.
            // $li.attr('data-elapsed-seconds', totalTiming);
            setStageMetric(stageId, 'elapsedSeconds', totalTiming);
        } else {
            // $li.attr('data-elapsed-seconds', 0);
            setStageMetric(stageId, 'elapsedSeconds', 0);
        }
    }

    if(hasOtherChange) {
        log('Re-rendering Other Changes', stageId);
        // Transport
        let selectedTransport = 'walk'; // Default
        if(stage.transport) {
            selectedTransport = stage.transport;
        }
        $li.find('[data-label="stage-transport-icon"]').attr('class', window.ironman.appConfig.modesOfTransport[selectedTransport].icon);

        // Show date separator - Bcz here it will run once, on first render.
        $li.find('[data-label="stage-date-separator"]').removeClass('d-none');
    }

    // Always Re-Render
    
    // Indexing (Stage Number)
    
    // Get index of stage within the stageData array.
    const stageIndex = getStageIndexById(stageId);
    if (stageIndex === false) {
        // Shouldn't happen.
        return false;
    }
    $li.find('[data-label="stage-number"]').text(stageIndex + 1);

    // Calculate Date
    const stage_date = getStageDateById(stageId);
    const date = new Date(stage_date);
    const date_string = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }).format(date);
    $li.find('[data-label="stage-date"]').text(date_string);

    // Show/Hide insert stage above link on top stage.
    if(stageIndex === 0) {
        $li.find('[data-label="insertStageAboveLink"]').removeClass('d-none');
    } else {
        $li.find('[data-label="insertStageAboveLink"]').addClass('d-none');
    }

    // Show/Hide reactivate stage link for completed stages
    if(stage.status === 'complete') {
        $li.find('[data-label="reactivateStageLink"]').removeClass('d-none');
    } else {
        $li.find('[data-label="reactivateStageLink"]').addClass('d-none');
    }
    
    return $li;
}

/*
Obsolete, replaced with singleStageShareModal_preview function.
function getShareMediaUrl(params={}) {
    // Set default params. Fills in whatever's missing from input params.
    let default_params = {
        // 'resolution': 'square',
        // 'ascent': ascent,
        // 'descent': descent,
        // 'background_image_url': false,
        // 'bounding_box': bounding_box_string,
        // 'bearing': Math.round(bearing * 100) / 100,
        // 'pitch': 60, // Set pitch to 0 for a flat view
        // 'center_point': centerPoint,
        'itinerary_id': window.ironman.itineraryId,
        'render_type': 'map_overlay',
    };

    // Merge the default params with the params. Prioritize the params over the defaults.
    const mergedParams = { ...default_params, ...params };

    // Create the payload.
    const payload = {
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce,
        ...mergedParams
    };

    // Call the admin ajax function. Use callbacks to handle the response.
    callAdminAjax('getShareMediaUrl', payload, 'getShareMediaUrl', {
        onSuccess: (response) => {
            log('Success:', response);
        },
        onFail: (error) => {
            log('Error:', error);
        }
    });
}
window.getShareMediaUrl = getShareMediaUrl;
*/

/**
 * Rename the itinerary.
 * @param {string} newName - The new name of the itinerary.
 */
function renameItinerary(newName) {
    if(!newName || newName.length < 3 || newName.length > 100) {
        return false;
    }

    const payload = {
        itinerary_id: window.ironman.itineraryId,
        new_name: newName,
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce
    };
    callAdminAjax('renameItinerary', payload, 'renameItinerary', {
        onSuccess: (response) => {
            log('Success:', response);
            if(response.success && response.data.new_name) {
                // Update the itinerary name in UI and global var
                window.ironman.itineraryData.name = response.data.new_name;
                $('#itinerary-name').text(response.data.new_name);
            } else {
                alert('Error renaming itinerary: '+response.data.message);
            }
        },
        onFail: (error) => {
            log('Error:', error);
        }
    }, 'non-blocking', t('savingChangesSpinnerMessage'));
}

function updateItineraryDescription(newDescription) {
    
    const payload = {
        itinerary_id: window.ironman.itineraryId,
        new_description: newDescription,
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce
    };
    callAdminAjax('updateItineraryDescription', payload, 'updateItineraryDescription', {
        onSuccess: (response) => {
            log('Success:', response);
            if(response.success && response.data.new_description) {
                // Update the itinerary description in UI and global var
                window.ironman.itineraryData.description = response.data.new_description;
                $('#itinerary-description').text(response.data.new_description);
            } else {
                alert('Error updating itinerary description: '+response.data.message);
            }
        },
        onFail: (error) => {
            log('Error:', error);
        }
    }, 'non-blocking', t('savingChangesSpinnerMessage'));
}

async function changeItineraryCompleteStatus(newIsComplete=false) {
    const payload = {
        itinerary_id: window.ironman.itineraryId,
        new_is_complete: newIsComplete ? 'true' : 'false',
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce
    };
    
    const response = await callAdminAjax('changeItineraryCompleteStatus', payload, 'changeItineraryCompleteStatus', null, 'non-blocking', t('savingChangesSpinnerMessage'));
    return response;
}

/**
 * Change the itinerary publish status.
 * @param {string} publishStatus - The new publish status of the itinerary.
 */
function changeItineraryPublishStatus(newIsPublished=false) {
    const payload = {
        itinerary_id: window.ironman.itineraryId,
        new_is_published: newIsPublished ? 'true' : 'false',
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce
    };
    callAdminAjax('changeItineraryPublishStatus', payload, 'changeItineraryPublishStatus', {
        onSuccess: (response) => {
            log('Success:', response);
        },
        onFail: (error) => {
            log('Error:', error);
        }
    }, 'non-blocking', t('savingChangesSpinnerMessage'));
}

/**
 * Change the itinerary privacy.
 * @param {string} privacy - The new privacy of the itinerary.
 */
async function changeItineraryPrivacy(privacy) {
    if(!privacy || !['members-shared','members','friends','private'].includes(privacy)) {
        return false;
    }

    const payload = {
        itinerary_id: window.ironman.itineraryId,
        privacy: privacy,
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce
    };
    const response = await callAdminAjax('changeItineraryPrivacy', payload, 'changeItineraryPrivacy', null, 'non-blocking', t('savingChangesSpinnerMessage'));

    return response;
}

/**
 * Duplicate an itinerary.
 * @param {string} itineraryId - The id of the itinerary to duplicate.
 */
async function duplicateItinerary(itineraryId) {
    const payload = {
        itinerary_id: itineraryId,
        _ajax_nonce: window.ironman.gnonce
    };
    const response = await callAdminAjax('duplicateItinerary', payload, 'duplicateItinerary', null, 'page-blocking', t('copyingCaminoSpinnerMessage'));
    return response;
}

// ------------------------------------------------------
// Fenix Modal Functions -------------------------------
// ------------------------------------------------------

async function showSingleStageShareModal(stageId=null) {
    log('showSingleStageShareModal', stageId);
    if(!stageId) {
        log('showSingleStageShareModal: Missing stage id');
        return false;
    }

    // Validate the stage id
    const stage = getStageData(stageId);
    if(!stage) {
        log('showSingleStageShareModal: Invalid stage id', stageId);
        return false;
    }

    // Save the stage id to the global variable.
    singleStageShareModal_stageId = stageId;

    // Get the media gallery, split by type.
    const { stageImages, stageVideos } = splitMediaGalleryByType(window.ironman.postMediaGallery[stageId] || []);

    // Update the Fenix modal with the share single stage modal content.
    await setFenixBackdrop(true);
    const modalTitle = t('shareStageModal_title');
    const modalFooter = getTemplate('singleStageShareModalFooterTemplate');
    const modalDesktopSize = 'lg';
    const modalMobileHeight = null; //Use default height.
    const modalDataPurpose = 'singleStageShare'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    // console.time('openFenixModal');
    await openFenixModal();
    // console.timeEnd('openFenixModal');
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    // await delay(100); //wait N milliseconds for testing.

    let modalBody = getTemplate('singleStageShareModalTemplate');
    // Start customizing the modal body...

    const swiperItemTemplate = getTemplate('imageSelectSwiperItemTemplate');
    log('swiperItemTemplate', swiperItemTemplate);

    // Build the photo tab swiper items
    if(stageImages.length > 0) {
        const photosSwiperItems = getSwiperMediaItems(stageImages, swiperItemTemplate);
        
        //Check the first item by default
        if(photosSwiperItems.length > 0) {
            $(photosSwiperItems[0]).find('input').prop('checked', true);
        }

        // If less than 4 photos are added, fetch more photos. This is to ensure the swiper instance is populated with at least 4 photos.
        // Note: fetchAllMedia will validate that there are more photos to fetch.
        if(photosSwiperItems.length < 4) {
            singleStageShare_fetchAllMedia(singleStageShareModal_stageId);
        }

        // Add the swiper items to the modal body
        modalBody.find('#photos-tab-pane').find('.swiper-wrapper').empty().append(photosSwiperItems);
    } else {
        modalBody.find('#photos-tab-pane').find('.swiper-wrapper').empty().html('<p>'+t('noPhotosAddedToStage')+'</p>');
    }

    // Build the video tab swiper items
    if(stageVideos.length > 0) {
        const videosSwiperItems = getSwiperMediaItems(stageVideos, swiperItemTemplate);
        
        //Check the first item by default
        if(videosSwiperItems.length > 0) {
            $(videosSwiperItems[0]).find('input').prop('checked', true);
        }
        
        // Add the swiper items to the modal body   
        modalBody.find('#video-tab-pane').find('.swiper-wrapper').empty().append(videosSwiperItems);
    } else {
        modalBody.find('#video-tab-pane').find('.swiper-wrapper').empty().html('<p>'+t('noVideosAddedToStage')+'</p>');
    }

    // Build the map style swiper items
    const mapStyles = window.ironman.appConfig.mapStyles;
    if(Object.keys(mapStyles).length > 0) {
        const mapSwiperItems = [];
        Object.entries(mapStyles).forEach(([key, style]) => {
            log('singleStageShareModal: Adding swiper item for map style', key, style);
            const item = swiperItemTemplate.clone();
            item.find('img').attr('src', style.thumbnail_url);
            // item.find('input').attr('id', 'map-item-'+key);
            item.find('input').attr('name', 'map-style');
            // item.find('label').attr('for', 'map-item-'+key);
            item.find('input').attr('value', key);

            // Check user permission to use this map style
            if(window.ironman.userData.permissions.allowedMapStyles.includes(key)) {
                item.find('input').prop('disabled', false);
            } else {
                item.find('input').prop('disabled', true);
                item.find('label').addClass('upgrade-required');
            }

            mapSwiperItems.push(item);
        });

        //Check the first item by default
        mapSwiperItems[0].find('input').prop('checked', true);
        
        // Add the swiper items to the modal body
        modalBody.find('#map-tab-pane').find('.swiper-wrapper').empty().append(mapSwiperItems);
    } else {
        modalBody.find('#map-tab-pane').find('.swiper-wrapper').empty().html('<p>'+t('noMapStylesAvailable')+'</p>');
    }

    // Set default settings based on user permissions.

    const userData = window.ironman.userData;
    const permissions = userData.permissions;
    const settingsForm = modalBody.find('#singleStageShare-settings-form');

    if(permissions.includeStageStatsInShareMedia) {
        settingsForm.find('label[for="singleStageShare-stageStats"]').find('span.labelUpgradeRequired').hide();
    } else {
        settingsForm.find('input#singleStageShare-stageStats').prop('disabled', true);
        settingsForm.find('input#singleStageShare-stageStats').prop('checked', false);
    }

    if(permissions.includeExtraStatsInShareMedia) {
        settingsForm.find('label[for="singleStageShare-extraStats"]').find('span.labelUpgradeRequired').hide();
    } else {
        settingsForm.find('input#singleStageShare-extraStats').prop('disabled', true);
        settingsForm.find('input#singleStageShare-extraStats').prop('checked', false);
    }

    if(permissions.includeMiniMapInShareMedia) {
        settingsForm.find('label[for="singleStageShare-miniMap"]').find('span.labelUpgradeRequired').hide();
    } else {
        settingsForm.find('input#singleStageShare-miniMap').prop('disabled', true);
        settingsForm.find('input#singleStageShare-miniMap').prop('checked', false);
    }

    if(permissions.includeMegaMapInShareMedia) {
        settingsForm.find('label[for="singleStageShare-routeLine"]').find('span.labelUpgradeRequired').hide();
    } else {
        settingsForm.find('input#singleStageShare-routeLine').prop('disabled', true);
        settingsForm.find('input#singleStageShare-routeLine').prop('checked', false);
    }

    if(permissions.includeElevationInShareMedia) {
        settingsForm.find('label[for="singleStageShare-elevationChart"]').find('span.labelUpgradeRequired').hide();
    } else {
        settingsForm.find('input#singleStageShare-elevationChart').prop('disabled', true);
        settingsForm.find('input#singleStageShare-elevationChart').prop('checked', false);
    }

    if(permissions.hideLogoFromShareMedia) {
        settingsForm.find('label[for="singleStageShare-hideLogo"]').find('span.labelUpgradeRequired').hide();
    } else {
        settingsForm.find('input#singleStageShare-hideLogo').prop('disabled', true);
        settingsForm.find('input#singleStageShare-hideLogo').prop('checked', false);
    }

    // Set distance units.
    if(userData.userPreferences.distance_units === 'imperial') {
        settingsForm.find('input#distance-units-imperial').prop('checked', true);
    } else {
        settingsForm.find('input#distance-units-metric').prop('checked', true);
    }


    // End customizing the modal body...

    // Set the modal content
    setFenixModalContent(true, modalBody, true, true, true, true);

    // Open the modal
    // openFenixModal();
}
window.showSingleStageShareModal = showSingleStageShareModal;

function singleStageShareModal_preview() {

    // Get the stage id from the global variable and validate it.
    const stageId = singleStageShareModal_stageId;
    if(!stageId) {
        log('singleStageShareModal_preview: Missing stage id');
        return false;
    }

    // Get the stage data.
    const stage = getStageData(stageId);
    if(!stage) {
        log('singleStageShareModal_preview: Invalid stage id', stageId);
        return false;
    }

    // Get the path data for the stage.
    // const pathData = getSingleStagePathData(stageId);
    // if(!pathData) {
    //     log('singleStageShareModal_preview: Invalid path data', stageId);
    //     return false;
    // }

    let render_type = null;
    let photos_image = null;
    let map_style = null;

    // Get the active tab
    const activeTab = $('#singleStageShareModalDialog').find('#singleStageShare-tabs').find('button.active').attr('id');
    log('activeTab', activeTab);

    // Handle Tabs
    if(activeTab === 'photos-tab') {
        render_type = 'photo_overlay';

        const photos_form = $('#singleStageShareModalDialog').find('#singleStageShare-photos-form');
        const photos_form_values = new FormData(photos_form[0]);

        photos_image = photos_form_values.get('media-image');

        log('photos_image', photos_image);
    } else if(activeTab === 'map-tab') {
        render_type = 'map_overlay';

        const map_form = $('#singleStageShareModalDialog').find('#singleStageShare-map-form');
        const map_form_values = new FormData(map_form[0]);

        map_style = map_form_values.get('map-style');
        log('map_style', map_style);
    } else if(activeTab === 'videos-tab') {
        // Todo.
    }

    // Size
    const sizeForm = $('#singleStageShareModalDialog').find('#singleStageShare-size-form');
    const size_form_values = new FormData(sizeForm[0]);
    const render_size = size_form_values.get('photos-size');
    log('render_size', render_size);
    
    // Settings
    const settingsForm = $('#singleStageShareModalDialog').find('#singleStageShare-settings-form');
    const settings_form_values = new FormData(settingsForm[0]);

    const overlays = settings_form_values.getAll('overlays');

    const includeStageInfo = overlays.includes('stage-info');
    const includeStageStats = overlays.includes('stage-stats');
    const includeExtraStats = overlays.includes('extra-stats');
    const includeMiniMap = overlays.includes('mini-map');
    const includeRouteLine = overlays.includes('route-line');
    const includeElevationChart = overlays.includes('elevation-chart');
    const hideLogo = overlays.includes('hide-logo');

    // Advanced Settings
    const distance_units = settings_form_values.get('distance-units');
    const pace_or_speed = settings_form_values.get('pace-or-speed');
    
    // Get the share media url.
    const payload = {
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce,
        itinerary_id: window.ironman.itineraryId,
        render_type: render_type,
        size: render_size,
        stage_id: stageId,
        include_place_names: includeStageInfo,
        include_stage_stats: includeStageStats,
        include_extra_stats: includeExtraStats,
        include_mini_map: includeMiniMap,
        include_mega_map: includeRouteLine,
        include_elevation: includeElevationChart,
        hide_logo: hideLogo ? 'true' : 'false',
        custom_language: false,
        custom_distance_units: distance_units,
        custom_locale: false,
        // custom_crop: false,
        show_pace_instead_of_speed: pace_or_speed === 'pace' ? 'true' : 'false',
    };
    if(map_style) {
        payload.map_style = map_style;
    }
    if(photos_image) {
        payload.media_ids = photos_image;
    }

    log('payload', payload);


    // Show loading placeholder image before the ajax call. If a button is provided, disable it.
    const previewImageContainer = $('#singleStageShareModalDialog').find('#singleStageShareModalPreviewImageContainer');
    previewImageContainer.html('<div class="placeholder-glow"><span class="placeholder col-12" style="height: 200px;"></span></div>');

    const previewButton = $('#fenixFooter').find('#singleStageShareModalPreviewButton');
    const downloadButton = $('#fenixFooter').find('#singleStageShareModalDownloadButton');
    previewButton.attr('disabled', 'disabled');
    downloadButton.attr('disabled', 'disabled');

    // Call the admin ajax function. Use callbacks to handle the response.
    callAdminAjax('getShareMediaUrl', payload, 'getShareMediaUrl', {
        onSuccess: (response) => {
            log('Success:', response);
            // Update the preview image with the share media url.
            previewImageContainer.html('<img id="singleStageShareModalPreviewImage" src="'+response.data.url+'" />');
            // const previewImage = $('#singleStageShareModalDialog').find('#singleStageShareModalPreviewImage');
            // previewImage.attr('src', response.data.url);

            // Enable the buttons.
            downloadButton.removeAttr('disabled');
            previewButton.removeAttr('disabled');
        },
        onFail: (error) => {
            log('Error:', error);
            
            //Enable Preview button.
            previewButton.removeAttr('disabled');
        }
    });

    // Update the preview image with the share media url.
    // const previewImage = $('#singleStageShareModalDialog').find('#singleStageShare-preview-image');
    // previewImage.attr('src', shareMediaUrl);
}
window.singleStageShareModal_preview = singleStageShareModal_preview;

/**
 * Fetch all the media for the given stage and add it to the swiper instances.
 * @param {string} stageId - The id of the stage to fetch the media for.
 */
function singleStageShare_fetchAllMedia(stageId) {
    log('singleStageShare_fetchAllMedia', stageId);

    // Set the inflight fetch more request flag.
    inflightFetchMoreRequests['singleStageShare_'+stageId] = true;
                        
    // Has to grab all the items at once to maintain order, due to separation of images and videos. Could start from current offset, but may as well start from 0.
    const data = {
        post_id: window.ironman.postId,
        child_id: stageId,
        offset: 0,
        limit: 200,
    };

    callAdminAjax('querySinglePostMediaGallery', data, 'querySinglePostMediaGallery_'+stageId, {
        onSuccess: (response) => {
            if(response.success === true) {
                log('Post media gallery downloaded successfully.');

                // Count the existing items in the window.ironman.postMediaGallery.
                const preCount = window.ironman.postMediaGallery?.[stageId]?.length || 0;
                log('swiperInstance: Pre count', preCount);

                // Remove that many from the front of the query results.
                const queryResultsSlice = response.data.query_results.slice(preCount);

                // Replace the existing items in the window.ironman.postMediaGallery with the FULL query results.
                window.ironman.postMediaGallery[stageId] = response.data.query_results;

                // Get the swiper item template.
                const swiperItemTemplate = getTemplate('imageSelectSwiperItemTemplate');

                // Split the new slice by type.
                const { stageImages, stageVideos } = splitMediaGalleryByType(queryResultsSlice);
                log('swiperInstance: Stage images', stageImages);
                log('swiperInstance: Stage videos', stageVideos);

                // Get the items from the media and add the new items to swiper instance.
                if(stageImages.length > 0) {
                    // Get the swiper items for the new images.
                    const newImages = getSwiperMediaItems(stageImages, swiperItemTemplate);
                    log('swiperInstance: New images', newImages);

                    // Add the new images to the swiper instance.
                    if(swiperInstances_photos[stageId] && !swiperInstances_photos[stageId].destroyed) {
                        swiperInstances_photos[stageId].appendSlide(newImages);
                        log('swiperInstance: Added new images to photos stage', stageId);
                    } else {
                        log('swiperInstance: No swiper instance found for photos stage', stageId);
                    }
                }

                if(stageVideos.length > 0) {
                    // Get the swiper items for the new videos.
                    const newVideos = getSwiperMediaItems(stageVideos, swiperItemTemplate);
                    log('swiperInstance: New videos', newVideos);

                    // Add the new videos to the swiper instance.
                    if(swiperInstances_videos[stageId] && !swiperInstances_videos[stageId].destroyed) {
                        swiperInstances_videos[stageId].appendSlide(newVideos);
                        log('swiperInstance: Added new videos to videos stage', stageId);
                    } else {
                        log('swiperInstance: No swiper instance found for videos stage', stageId);
                    }
                }
                
            } else {
                log('error getting post media gallery items.');
            }
        },
        onFail: (error) => {
            log('error getting post media gallery.');
        },
        onComplete: (response) => {
            // May as well keep it "inflight" because everything's been fetched.
            // inflightFetchMoreRequests['singleStageShare_'+stageId] = false;
        }
    }, 'non-blocking', t('downloadingMediaItemsSpinnerMessage'));
}

/**
 * Setup the single stage share swiper instance AFTER it has been initialized.
 * Specifically, set it up to fetch more items when the user is nearing the end of the swiper instance.
 * @param {Element} el - The element to setup the swiper instance for.
 * @param {Swiper} swiperInstance - The swiper instance to setup.
 */
export function singleStageShare_setupSwiper(el, swiperInstance) {
    // Get the stage id from the global variable.
    let stageId = singleStageShareModal_stageId;
    if(stageId && stageId !== 'root') {
        stageId = String(parseInt(stageId));
    }
    if(!stageId) {
        return false;
    }

    // Save the new swiper instance to the global variables by stage id and content type.
    const contentType = el.getAttribute('data-swiper-content-type');
    if(contentType === 'photos') {
        swiperInstances_photos[stageId] = swiperInstance;
    } else if(contentType === 'videos') {
        swiperInstances_videos[stageId] = swiperInstance;
    }

    log('swiperInstances_photos', swiperInstances_photos);
    log('swiperInstances_videos', swiperInstances_videos);

    // Add the slide change event listener to the swiper instance.
    swiperInstance.on("slideChange", () => {
        log('swiperInstance: slideChange');

        const remaining = swiperInstance.slides.length - 1 - swiperInstance.activeIndex;
        log('swiperInstance: remaining', remaining);
        const PREFETCH_AHEAD = 3;

        if (remaining <= PREFETCH_AHEAD) {
            // Check that there are remaining slides to fetch.
            const total = window.ironman.postMediaGalleryCounts[stageId] || 0;
            if(total === window.ironman.postMediaGallery[stageId].length) {
                log('swiperInstance: No remaining slides to fetch for stage', stageId);
                return;
            }

            // Check if a fetch more request is already in flight for this stage.
            if(inflightFetchMoreRequests['singleStageShare_'+stageId]) {
                log('swiperInstance: Fetch more items already in flight for stage', stageId);
                return;
            }

            log('swiperInstance: Fetching more items');

            // Fetch all the media for the stage and add it to the swiper instances.
            singleStageShare_fetchAllMedia(stageId);
        }
    });
}

async function showStageCommentEditModal(stageId) {
    log('showStageCommentEditModal', stageId);
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('editStageCommentModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'editStageComment'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('save')).attr('data-action', 'editStageCommentModal_submit').attr('data-stage-id', stageId);

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('editStageCommentModalTemplate');
    
    // Start customizing the modal body...
    const stageData = getStageData(parseInt(stageId));
    log('stageData', stageData);

    modalBody.find('#editStageCommentTextarea').val(stageData.user_comment || '');
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

async function showStagePrivateNoteEditModal(stageId) {
    log('showStagePrivateNoteEditModal', stageId);
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('addPrivateNoteModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'editStagePrivateNote'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('save')).attr('data-action', 'editStagePrivateNoteModal_submit').attr('data-stage-id', stageId);

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('editStagePrivateNoteModalTemplate');
    
    // Start customizing the modal body...
    const stageData = getStageData(parseInt(stageId));
    log('stageData', stageData);

    modalBody.find('#editStagePrivateNoteTextarea').val(stageData.private_note || '');
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

async function showSelectTransportModePopup(stageId) {
    log('showSelectTransportModePopup', stageId);
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('selectTransportModeModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'editTransportMode'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('save')).attr('data-action', 'editTransportModeModal_submit').attr('data-stage-id', stageId);

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('singleStageItem_editModeTemplate');
    
    // Start customizing the modal body...
    const stageData = getStageData(parseInt(stageId));
    log('stageData', stageData);

    let preset = 'walk';
    if(stageData.transport) {
        preset = stageData.transport;
    }

    // Get the transport mode list container
    const $transportModeList = modalBody.find('[data-label="singleStageItem_editModeList"]');

    // Loop through the transport modes and add them to the list.
    const modes = [];
    const itemTemplate = getTemplate('singleStageItem_editModeTemplate_item');
    Object.keys(window.ironman.appConfig.modesOfTransport).forEach(mode => {
        const item = itemTemplate.clone();
        item.find('[data-label="transportRadio"]').val(mode);
        item.find('[data-label="transportIcon"]').addClass(window.ironman.appConfig.modesOfTransport[mode].icon);
        item.find('[data-label="transportName"]').text(window.ironman.appConfig.modesOfTransport[mode].name);
        if(mode === preset) {
            log('Setting preset transport mode', mode);
            item.find('[data-label="transportRadio"]').prop('checked', true);
        }
        modes.push(item);
    });

    // Add the modes to the list.
    $transportModeList.append(modes);
    
    // modalBody.find('#editStageCommentTextarea').val(stageData.user_comment || '');
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

async function showEditDatePopup(stageId) {
    log('showEditDatePopup', stageId);
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('selectDateModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'editDate'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('save')).attr('data-action', 'editDatePopup_submit').attr('data-stage-id', stageId);

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('singleStageItem_editDateTemplate');
    
    // Start customizing the modal body...

    // Get index of stage in stageData array.
    const stageIndex = getStageIndexById(stageId);
    if(stageIndex === 0) {
        // If the stage is the first stage, show the Camino Created Date label.
        modalBody.find('[data-label="camino-created-date-label"]').removeClass('d-none');
        modalBody.find('[data-label="day-after-previous-stage-label"]').addClass('d-none');
    }

    const stageData = getStageData(parseInt(stageId));
    log('stageData', stageData);

    // Set initial value
    if(stageData.date && isValidDateString(stageData.date)) {
        modalBody.find('[data-label="custom-date-radio"]').prop('checked', true);
        modalBody.find('[data-label="custom-date-input"]').val(stageData.date);
    } else {
        modalBody.find('[data-label="day-after-previous-stage-radio"]').prop('checked', true);
        // Set the date input value to match the implied date via getStageDateById().
        modalBody.find('[data-label="custom-date-input"]').val(getStageDateById(stageId) || '');
    }

    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);   
}

async function showEditIntervalsPopup(stageId) {
    log('showEditIntervalsPopup', stageId);
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('editIntervalsModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'editIntervals'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('save')).attr('data-action', 'editIntervalsModal_submit').attr('data-stage-id', stageId);

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('singleStageItem_editIntervalsTemplate');
    
    // Start customizing the modal body...
    const stageData = getStageData(parseInt(stageId));
    log('stageData', stageData);

    // Set initial value
    // modalBody.find('#editStageCommentTextarea').val(stageData.user_comment || '');
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

/**
 * Helper function to reindex the server stageData array if it gets unindexed.
 * Untested.
 */
// function helper_reindexServerData() {
//     log('helper_reindexServerData');
//     return saveStageDataToServer(1, 'reindexServerData'); //StageId=1 to pass validation. Not used.
// }
// window.helper_reindexServerData = helper_reindexServerData;


function updateItineraryStats() {
    log('updateItineraryStats');

    // Initialize totals.
    let totalDistanceMeters = 0;
    let totalDistanceMeters_elapsed = 0;
    let totalAscentMeters = 0;
    let totalAscentMeters_elapsed = 0;
    let totalDescentMeters = 0;
    let totalDescentMeters_elapsed = 0;
    let totalTravelDays = 0;
    let totalTravelDays_elapsed = 0;

    let avgDailyDistanceMeters = 0;
    let avgDailyDistanceMeters_elapsed = 0;
    let totalElapsedSeconds = 0;

    // Loop through the stage data and sum the metrics.
    $.each(stageData, function(index, stage) {
        // Normalize values
        const stageDistanceMeters = parseInt(stage.metrics.distance) || 0;
        const stageAscentMeters = parseInt(stage.metrics.ascent) || 0;
        const stageDescentMeters = parseInt(stage.metrics.descent) || 0;
        const stageElapsedSeconds = parseInt(stage.metrics.elapsedSeconds) || 0;

        if(stageDistanceMeters > 0) {
            totalDistanceMeters += stageDistanceMeters;
            totalAscentMeters += stageAscentMeters;
            totalDescentMeters += stageDescentMeters;
            totalTravelDays++;

            if(stage.status === 'complete') {
                totalDistanceMeters_elapsed += stageDistanceMeters;
                totalAscentMeters_elapsed += stageAscentMeters;
                totalDescentMeters_elapsed += stageDescentMeters;
                totalTravelDays_elapsed++;
            }
        }
        totalElapsedSeconds += stageElapsedSeconds;
    });
    
    if(totalTravelDays > 0 && totalDistanceMeters > 0) {
        avgDailyDistanceMeters = totalDistanceMeters / totalTravelDays;
    }
    if(totalDistanceMeters_elapsed > 0 && totalTravelDays_elapsed > 0) {
        avgDailyDistanceMeters_elapsed = totalDistanceMeters_elapsed / totalTravelDays_elapsed;
    }

    // Update the itinerary stats.
    const $statsContainer = $('#offcanvas-route-stats');
    $statsContainer.find('[data-label="itineraryStats_totalDistance"]').text(' / '+displayLongDistance(totalDistanceMeters));
    $statsContainer.find('[data-label="itineraryStats_totalDistance_elapsed"]').text(displayLongDistance(totalDistanceMeters_elapsed));
    $statsContainer.find('[data-label="itineraryStats_totalAscent"]').text(' / '+displayShortDistance(totalAscentMeters));
    $statsContainer.find('[data-label="itineraryStats_totalAscent_elapsed"]').text(displayShortDistance(totalAscentMeters_elapsed));
    $statsContainer.find('[data-label="itineraryStats_totalDescent"]').text(' / '+displayShortDistance(totalDescentMeters));
    $statsContainer.find('[data-label="itineraryStats_totalDescent_elapsed"]').text(displayShortDistance(totalDescentMeters_elapsed));
    $statsContainer.find('[data-label="itineraryStats_totalTravelTime"]').text(displayElapsedTime(totalElapsedSeconds));

    // Speed = Distance / Time
    let speed = 0;
    if(totalElapsedSeconds > 0 && totalDistanceMeters_elapsed > 0) {
        const km = totalDistanceMeters_elapsed / 1000;
        const hour = totalElapsedSeconds / 3600;
        speed = round2(km / hour);
    }
    $statsContainer.find('[data-label="itineraryStats_avgTravelSpeed"]').text(speed+' km/h');
    
    // Save the total distance to the itinerary data global var for later use.
    window.ironman.itineraryData.totalDistanceMeters = totalDistanceMeters;

    let travelDaysUnit = t('days');
    if(totalTravelDays == 1) {
        travelDaysUnit = t('day');
    }
    let travelDaysUnit_elapsed = t('days');
    if(totalTravelDays_elapsed == 1) {
        travelDaysUnit_elapsed = t('day');
    }

    $statsContainer.find('[data-label="itineraryStats_travelDays_elapsed"]').text(totalTravelDays_elapsed + ' ' + travelDaysUnit_elapsed);
    $statsContainer.find('[data-label="itineraryStats_travelDays"]').text(' / '+totalTravelDays + ' ' + travelDaysUnit);
    
    $statsContainer.find('[data-label="itineraryStats_avgDailyDistance_elapsed"]').text(displayLongDistance(avgDailyDistanceMeters_elapsed));
    $statsContainer.find('[data-label="itineraryStats_avgDailyDistance"]').text(' / '+displayLongDistance(avgDailyDistanceMeters));
    
}

// Check if the Stage Details are visible, and if so, update them.
function maybeRenderStageDetails(stageId) {
    const stage = getStageData(parseInt(stageId));
    if(!stage) {
        log('Missing stage data', stageId);
        return false;
    }

    const $li = $stagesContainer.find(`[data-label="singleStageItem"][data-stage-id="${stage.id}"]`);
    const $stageDetailsCollapse = $li.find('[data-label="stage-details-collapse"]');
    if($stageDetailsCollapse.hasClass('show')) {
        log('Stage details visible, re-rendering', stageId);
        return renderStageDetails(stageId);
    } else {
        return false;
    }
}

function renderStageDetails(stageId) {
    // Get the stage data.
    const stage = getStageData(parseInt(stageId));
    if(!stage) {
        log('Missing stage data', stageId);
        return false;
    }

    const $li = $stagesContainer.find(`[data-label="singleStageItem"][data-stage-id="${stage.id}"]`);
    const $placeListContainer = $li.find('ul.place-list-container');
    
    if ($li.data('detailsLoaded')) {
        return true; // Already loaded.
    } else {
        // Not loaded yet. Load stage details.

        // Validate the stage data.
        if(stage.route && stage.origin && stage.destination) {
            // Continue
        } else {
            // Incomplete path data. Hide title and clear the list.
            $li.find('[data-label="stage-stops-title"]').addClass('d-none'); // Hide title.
            $placeListContainer.empty(); // Clear the list.
            return false;
        }

        // Start Rendering the stage stops content.        
        if($placeListContainer) {

            // Existence validated earlier.
            const routeId = parseInt(stage.route);
            const direction = stage.direction === 'r' ? 'reverse' : 'forward';
            const originId = parseInt(stage.origin);
            const destinationId = parseInt(stage.destination);

            let checkedViaIds = [];
            if(stage.via) {
                stage.via.split(',').forEach(via => {
                    checkedViaIds.push(parseInt(via));
                });
            }

            // Build the route places list every time the modal is opened.
            const allRoutePlaces = getRoutePlaces(routeId, direction, originId);
            // log('allRoutePlaces', allRoutePlaces);

            let listType = 'stoplist';
            $placeListContainer.attr('data-list-type', listType);
            $placeListContainer.attr('data-cache-key', 'singleStageStoplist-'+stageId);

            // Add child route places to the route places.
            let filteredRoutePlaces = addChildRoutePlaces(allRoutePlaces, direction);

            // Slice the route places from the origin.
            if(originId) {
                filteredRoutePlaces = sliceRoutePlacesFromOrigin(filteredRoutePlaces, originId);
                
                if(destinationId) {
                    filteredRoutePlaces = sliceRoutePlacesToDestination(filteredRoutePlaces, destinationId);
                }

                // Add calculated values from the origin (Distance, Ascending, Descending)
                filteredRoutePlaces = addCalculatedValuesFromOrigin(filteredRoutePlaces, routeId, originId);
            }

            // Save to global var (for future reference, e.g. search filtering, recalculating distances on toggle change..)
            // NO SEARCHING OR TOGGLES ENABLED FOR SINGLE STAGE STOPLIST. NO NEED TO SAVE TO GLOBAL VAR.
            // setGlobalPathStops('singleStageStoplist-'+stageId, filteredRoutePlaces);

            // TODO:Hide unused shadow places.
            // filteredRoutePlaces = hideShadowRoutePlaces(filteredRoutePlaces, routeId, originId, destinationId, checkedViaIds);

            // log('filteredRoutePlaces', filteredRoutePlaces, listType);
            const listFragment = renderFilteredPlaceList(filteredRoutePlaces, listType, null, originId, destinationId, checkedViaIds, routeId, false, true, false, true, false);
            
            // Show Title
            $li.find('[data-label="stage-stops-title"]').removeClass('d-none');

            // Write list to the ul container.
            $placeListContainer.empty().append(listFragment);
        }
        $li.data('detailsLoaded', true); // prevent reloading. 
    }
}

async function showFinishedStagePopup(stageId) {
    log('showFinishedStagePopup', stageId);

    const stageData = getStageData(parseInt(stageId));
    if(!stageData) {
        log('Missing stage data', stageId);
        return false;
    }
    log('stageData', stageData);

    if(!stageData.route || !stageData.origin || !stageData.destination) {
        log('Missing path data', stageId);
        return false;
    }

    // Get path data from stage data.
    const routeData = getRouteById(parseInt(stageData.route));
    const originData = getPlaceById(parseInt(stageData.origin));
    const destinationData = getPlaceById(parseInt(stageData.destination));
    log('routeData', routeData);
    log('originData', originData);
    log('destinationData', destinationData);
    
    if(!routeData || !originData || !destinationData) {
        log('Missing path data', stageId);
        return false;
    }

    // Get the path data for the stage.
    const pathData = getSingleStagePathData(parseInt(stageId));
    log('pathData', pathData);
    if(!pathData) {
        log('Missing path data', stageId);
        return false;
    }
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('stageCompleted');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = null;
    const modalDataPurpose = 'finishedStagePopup'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('checkInToPlace', { placeName: destinationData.text })).attr('data-action', 'checkin').attr('data-checkin-post-id', destinationData.id);
    modalFooter.find('[data-label="fenixDefaultFooterCancelButton"]').text(t('close'));

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose, true);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('congratsPopupTemplate');
    
    // Start customizing the modal body...
    modalBody.find('[data-label="congratsTitle"]').text(t('welcomeToPlace!', { placeName: destinationData.text }));
    modalBody.find('[data-label="congratsMessage"]').text(t('youFinishedAStage!'));
    // modalBody.find('[data-label="originName"]').text(originData.text);
    modalBody.find('[data-label="originTitle"]').attr('href', '/place/'+originData.slug+'/').text(originData.text);
    // modalBody.find('[data-label="destinationName"]').text(destinationData.text);
    modalBody.find('[data-label="destinationTitle"]').attr('href', '/place/'+destinationData.slug+'/').text(destinationData.text);
    modalBody.find('[data-label="destinationStamp"]').attr('src', destinationData.stamp_image).attr('alt', destinationData.text);
    modalBody.find('[data-label="distance"]').text(displayLongDistance(pathData.pathData.distance));

    // if(stageData.time && stageData.time > 0 && stageData.pace && stageData.pace > 0) {
    //     modalBody.find('[data-label="time"]').text(displayLongTime(stageData.time));
    //     modalBody.find('[data-label="pace"]').text(displayLongPace(stageData.pace));
    //     modalBody.find('[data-label="timeAndPace"]').removeClass('d-none');
    // }

    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true, true);
}

async function showFinishedItineraryPopup() {
    log('showFinishedItineraryPopup');

    const stageData = window.ironman.stageData;
    if(stageData.length < 1) {
        log('No stage data', stageData);
        return false;
    }
    
    const firstStageData = stageData[0];
    const lastStageData = stageData[stageData.length - 1];
    
    if(!firstStageData.origin || !lastStageData.destination) {
        log('Missing path data', stageId);
        return false;
    }

    // Get path data from stage data.
    const originData = getPlaceById(parseInt(firstStageData.origin));
    const destinationData = getPlaceById(parseInt(lastStageData.destination));
    log('originData', originData);
    log('destinationData', destinationData);
    
    if(!originData || !destinationData) {
        log('Missing origin or destination data');
        return false;
    }

    // Get the total distance for the itinerary.
    const totalDistanceMeters = window.ironman.itineraryData.totalDistanceMeters ?? false;
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = null;
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = null;
    const modalDataPurpose = 'finishedItineraryPopup'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterPrimaryLink"]').text(t('viewCompostela')).attr('href', '/members/'+window.ironman.userData.username+'/credential/compostelas/').removeClass('d-none');
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').remove();
    modalFooter.find('[data-label="fenixDefaultFooterCancelButton"]').text(t('close'));

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose, true);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('congratsPopupTemplate');
    
    // Start customizing the modal body...
    modalBody.find('[data-label="congratsTitle"]').text(t('youEarnedACompostela!'));
    modalBody.find('[data-label="congratsMessage"]').text(t('youFinishedACamino!'));
    // modalBody.find('[data-label="originName"]').text(originData.text);
    modalBody.find('[data-label="originTitle"]').attr('href', '/place/'+originData.slug+'/').text(originData.text);
    // modalBody.find('[data-label="destinationName"]').text(destinationData.text);
    modalBody.find('[data-label="destinationTitle"]').attr('href', '/place/'+destinationData.slug+'/').text(destinationData.text);
    modalBody.find('[data-label="destinationStamp"]').attr('src', '/wp-content/themes/ironman/public/media/finishedCaminoStamp.png').attr('alt', 'Compostela stamp');
    if(totalDistanceMeters) {
        modalBody.find('[data-label="distance"]').text(displayLongDistance(totalDistanceMeters));
    }

    // if(stageData.time && stageData.time > 0 && stageData.pace && stageData.pace > 0) {
    //     modalBody.find('[data-label="time"]').text(displayLongTime(stageData.time));
    //     modalBody.find('[data-label="pace"]').text(displayLongPace(stageData.pace));
    //     modalBody.find('[data-label="timeAndPace"]').removeClass('d-none');
    // }

    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true, true);
}

async function showBrowsePopularCaminosPopup() {
    log('showBrowsePopularCaminosPopup');
    // Open the browse popular caminos popup.
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    const modalTitle = t('sharedCaminosModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = null;
    const modalDataPurpose = 'browsePopularCaminosPopup'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('copyCamino')).attr('data-action', 'createPopularCaminosPopup_submit');

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose, false);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('browsePopularCaminosPopupTemplate');
    
    // Start customizing the modal body...
    try {
        const caminoList = await updateSharedCaminos(true); // True means use default values.
        if(caminoList.length > 0) {
            modalBody.find('[data-label="browse-popular-caminos-list-container"]').empty().append(caminoList);
        } else {
            modalBody.find('[data-label="browse-popular-caminos-list-container"]').empty().append(getTemplate('browsePopularCaminosEmptyTemplate'));
        }
    } catch (error) {
        log('Error updating shared caminos', error);
        return false;
    }
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true, false);
}

async function updateSharedCaminos(defaults=true) {
    log('updateSharedCaminos', defaults);
    
    // Set filter values
    let filters = {
        limit: 20,
        offset: 0,
        order_by: 'popular',
        owner: 'staff',
        route: 'all',
        mode_of_transport: 'all',
    };
    if(defaults === false) {
        // Get active filter values and overwrite defaults.
        const $container = $('#browsePopularCaminosPopupContainer');
        if($container.length < 1) {
            log('updateSharedCaminos: no container found');
            return false;
        }

        // Order by filter
        const $orderByFilter = $container.find('#popular-caminos-sort-select').find('option:selected').val();
        const allowedOrders = ['popular', 'shortest', 'longest', 'slowest', 'fastest'];
        if(allowedOrders.includes($orderByFilter)) {
            filters.order_by = $orderByFilter;
        }

        // Mode of transport filter
        const $modeOfTransportFilter = $container.find('#popular-caminos-transport-select').find('option:selected').val();
        if($modeOfTransportFilter && isValidTransport($modeOfTransportFilter)) {
            filters.mode_of_transport = $modeOfTransportFilter;
        }

        // Route filter
        const $routeFilter = $container.find('#popular-caminos-route-filter').find('button.active').attr('data-value');
        const allowedRoutes = Object.values(window.ironman.appConfig.primaryRoutes).map(route => route.slug);
        if(allowedRoutes.includes($routeFilter)) {
            filters.route = $routeFilter;
        }

        // Owner filter
        const $ownerFilter = $container.find('#sharedCaminos_OwnerFilter').find('button.active').attr('data-value');
        if($ownerFilter === 'members') {
            filters.owner = 'members';
        }
    }
    
    // Get shared itineraries
    try {
        const sharedItineraries = await callAdminAjax('getSharedItineraries', filters, 'getSharedItineraries', null, 'non-blocking', t('loadingSharedCaminosSpinnerMessage'));

        if(sharedItineraries.success) {
            log('sharedItineraries', sharedItineraries);
        } else {
            log('Error getting shared itineraries', sharedItineraries);
            return false;
        }

        if(sharedItineraries.data.itineraries.length > 0) {
            // Get template for caminos
            const $itemTemplate = getTemplate('browsePopularCaminosSingleItemTemplate');
            const caminoList = [];
            for(const itinerary of sharedItineraries.data.itineraries) {
                log('itinerary', itinerary);
                const $item = $itemTemplate.clone();
                $item.find('input[data-label="radio-select"]').attr('value', itinerary.id);
                $item.find('[data-label="camino-name"]').attr('href', itinerary.owner_profile_url+'caminos/'+itinerary.slug+'/').text(itinerary.title);
                $item.find('[data-label="camino-distance"]').text(displayLongDistance(itinerary.total_distance_m));
                $item.find('[data-label="camino-description"]').text(itinerary.description);
                $item.find('[data-label="camino-origin"]').attr('href', '/place/'+itinerary.origin_slug+'/').text(itinerary.origin_name);
                $item.find('[data-label="camino-destination"]').attr('href', '/place/'+itinerary.destination_slug+'/').text(itinerary.destination_name);
                $item.find('[data-label="camino-icon"]').attr('src', itinerary.owner_profile_picture_url);
                $item.find('[data-label="camino-owner-link"]').attr('href', itinerary.owner_profile_url).text(itinerary.owner_display_name);
                $item.find('[data-label="stage-count"]').text(itinerary.total_stages);

                caminoList.push($item.clone());
            }
            return caminoList;
        } else {
            return false;
        }
    } catch (error) {
        log('Error getting shared itineraries', error);
        return false;
    }
}

async function filterSharedCaminos_click_change_handler() {
    const $container = $('#browsePopularCaminosPopupContainer').find('[data-label="browse-popular-caminos-list-container"]');
    if($container.length < 1) {
        log('filterSharedCaminos: no container found');
        return false;
    }

    // Replace container contents with loading placeholder.
    $container.empty().append(getTemplate('loadingPlaceholder'));

    try {
        const caminoList = await updateSharedCaminos(false);
        if(caminoList.length > 0) {
            log('filterSharedCaminos: caminoList', caminoList);
            $container.empty().append(caminoList);
        } else {
            log('filterSharedCaminos: no caminos found');
            $container.empty().append(getTemplate('browsePopularCaminosEmptyTemplate'));
        }
    } catch (error) {
        log('filterSharedCaminos error: ', error);
        $container.empty().append(getTemplate('browsePopularCaminosEmptyTemplate'));
        return false;
    }
}

function updateAllStagesEstimatedTime() {
    log('updateAllStagesEstimatedTime');
    // Loop through $lis and update the estimated times for each.
    $stagesContainer.find('[data-label="singleStageItem"]:not(.deleting)').each(function(index, item) {
        const stageId = $(item).attr('data-stage-id');
        const stage = getStageData(parseInt(stageId));
        if(stage?.pathData?.distance) {
            // If status is complete, skip this stage
            if(stage.status === 'complete') {
                log('Stage is complete, skipping', stageId);
                return;
            }

            // Update the estimated time.
            const $estimatedTime = $(item).find('[data-label="stage-estimated-time"]');
            const pace = window.ironman.paceKmh; // km/h
            const paceMs = pace * 1000 / 3600; // convert to m/s
            const estimatedTime = stage.pathData.distance / paceMs; // in seconds
            const estimatedTimeHours = Math.floor(estimatedTime / 3600);
            const estimatedTimeMinutes = Math.floor((estimatedTime % 3600) / 60);
            const estimatedTimeString = `${estimatedTimeHours}h ${estimatedTimeMinutes}m`;
            $estimatedTime.text(estimatedTimeString);
        } else {
            log('Missing stage/path data', stageId);
            return;
        }
    });
}

async function showDeleteItineraryPopup() {
    log('showDeleteItineraryPopup');
    // Open the delete itinerary popup.
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    // Update the Fenix modal with the delete itinerary popup content.
    const modalTitle = t('deleteCaminoModal_title');
    const modalFooter = getTemplate('fenixDefaultFooterTemplate'); // Use the default footer template and customize it.
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'deleteItinerary'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Customize the default modal footer...
    modalFooter.find('[data-label="fenixDefaultFooterSaveButton"]').text(t('deleteCamino')).attr('data-action', 'deleteItineraryPopup_submit');

    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.

    let modalBody = getTemplate('deleteItineraryPopupTemplate');
    
    // Start customizing the modal body...
    
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

async function deleteItinerary(itineraryId) {
    log('deleteItinerary', itineraryId);
    // Delete the itinerary.
    const payload = {
        itinerary_id: itineraryId,
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.nonce
    };
    const response = await callAdminAjax('deleteItinerary', payload, 'deleteItinerary', null, 'page-blocking', t('deletingCaminoSpinnerMessage'));
    if(response.success) {
        // Redirect to the caminos list.
        window.location.href = '/members/'+window.ironman.userData.username+'/caminos/';
    } else {
        log('Error deleting itinerary: ', response);
        alert(t('anErrorHasOccurred'));
    }
    return response;
}